import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  getDashboardStats, 
  getDashboardRecent,
  getImoveis,
  getClientes,
  getCliente,
  getConstrutores,
  getConstrutor,
  deleteImovel,
  deleteCliente,
  deleteConstrutor,
  createImovel,
  createCliente,
  createConstrutor,
  getTags,
  updateImovel,
  updateCliente,
  updateConstrutor,
  adicionarImovelCliente,
  removerImovelCliente,
  getAgendamentos,
  createAgendamento,
  updateAgendamento,
  deleteAgendamento,
  getSituacoes,
  getStatusConstrucao,
  getClientesSituacoes,
  getTiposDocumento,
  getTiposVinculo
} from '../services/api';
import { maskCurrency, currencyToNumber, maskCEP, maskCPF, maskCNPJ, maskPhone, formatPhoneDisplay, formatCPFCNPJDisplay } from '../utils/masks';
import { buscarCEP } from '../utils/cep';
import { 
  FaHome, 
  FaUsers, 
  FaEdit,
  FaTrash,
  FaPlus
} from 'react-icons/fa';
import './Dashboard.css';
import './GerenciarImoveis.css';
import OverviewTab from './tabs/OverviewTab';
import ImoveisTab from './tabs/ImoveisTab';
import ClientesTab from './tabs/ClientesTab';
import ConstrutoresTab from './tabs/ConstrutoresTab';
import AgendamentosTab from './tabs/AgendamentosTab';
import LoadingOverlay from '../components/LoadingOverlay';

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'overview');
  
  // Estados para as tabelas
  const [imoveis, setImoveis] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [construtores, setConstrutores] = useState([]);
  const [agendamentos, setAgendamentos] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  
  // Estados para múltiplos imóveis
  const [totalImoveisCadastro, setTotalImoveisCadastro] = useState(1);
  const [unidadeAtual, setUnidadeAtual] = useState(1);
  const [dadosBaseImovel, setDadosBaseImovel] = useState(null);
  const [unidadesPendentes, setUnidadesPendentes] = useState([]);
  const [unidadesSalvasIds, setUnidadesSalvasIds] = useState([]);
  const [unidadeAtualAlterada, setUnidadeAtualAlterada] = useState(false);
  const justLoadedNextUnitRef = React.useRef(false);
  
  // Estados para pesquisa
  const [pesquisaImoveis, setPesquisaImoveis] = useState('');
  const [pesquisaClientes, setPesquisaClientes] = useState('');
  const [pesquisaConstrutores, setPesquisaConstrutores] = useState('');
  
  // Estados para paginação
  const [pageClientes, setPageClientes] = useState(1);
  const [itemsPerPageClientes, setItemsPerPageClientes] = useState(20);
  const [pageImoveis, setPageImoveis] = useState(1);
  const [itemsPerPageImoveis, setItemsPerPageImoveis] = useState(20);
  const [pageConstrutores, setPageConstrutores] = useState(1);
  const [itemsPerPageConstrutores, setItemsPerPageConstrutores] = useState(20);
  

  // Estados para modais de adicionar
  const [showImovelModal, setShowImovelModal] = useState(false);
  const [showClienteModal, setShowClienteModal] = useState(false);
  const [showConstrutorModal, setShowConstrutorModal] = useState(false);
  
  // Estados para edição
  const [editingImovel, setEditingImovel] = useState(null);
  const [editingCliente, setEditingCliente] = useState(null);
  const [editingConstrutor, setEditingConstrutor] = useState(null);
  
  // Estados para abas do modal de cliente
  const [clienteModalTab, setClienteModalTab] = useState('cliente');
  const [pesquisaImovelCliente, setPesquisaImovelCliente] = useState('');
  const [imoveisDisponiveis, setImoveisDisponiveis] = useState([]);
  const [imoveisRelacionadosCliente, setImoveisRelacionadosCliente] = useState([]);
  const [loadingImoveisCliente, setLoadingImoveisCliente] = useState(false);
  
  // Estados para abas do modal de construtor
  const [construtorModalTab, setConstrutorModalTab] = useState('construtor');
  const [pesquisaImovelConstrutor, setPesquisaImovelConstrutor] = useState('');
  const [imoveisDisponiveisConstrutor, setImoveisDisponiveisConstrutor] = useState([]);
  const [loadingImoveisConstrutor, setLoadingImoveisConstrutor] = useState(false);
  
  // Estados para formulário de imóvel
  const [imovelFormData, setImovelFormData] = useState({
    codigo: '',
    tipo: '',
    preco: '',
    totalImoveis: 1,
    areaConstruida: '',
    areaExterna: '',
    areaLote: '',
    possuiMultiplasUnidades: false,
    totalUnidades: '',
    unidadesDisponiveis: '',
    unidadesReservadas: '',
    unidadesVendidas: '',
    cep: '',
    rua: '',
    numero: '',
    bairro: '',
    cidade: '',
    estado: 'MG',
    quartos: '',
    banheiros: '',
    suites: '',
    lavabos: '',
    garagem: '',
    descricao: '',
    detalhes: '',
    observacoes: '',
    construtorId: '',
    situacao_id: '',
    status_construcao_id: '',
    disponivel: true,
    areaPrivativa: false,
    tags: [],
    fotos: []
  });
  const [tags, setTags] = useState([]);
  const [construtoresList, setConstrutoresList] = useState([]);
  const [situacoes, setSituacoes] = useState([]);
  const [statusConstrucaoList, setStatusConstrucaoList] = useState([]);
  const [clientesSituacoes, setClientesSituacoes] = useState([]);
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [tiposVinculo, setTiposVinculo] = useState([]);
  const [uploadingPhotos, setUploadingPhotos] = useState(false);
  const [savingImovel, setSavingImovel] = useState(false);
  const [savingCliente, setSavingCliente] = useState(false);
  const [savingConstrutor, setSavingConstrutor] = useState(false);
  const [codigoDuplicadoAviso, setCodigoDuplicadoAviso] = useState(null);
  
  // Estados para formulário de cliente
  const [clienteFormData, setClienteFormData] = useState({
    nome: '',
    tipoDocumento: 'CPF',
    cpfCnpj: '',
    acessoMidia: '',
    dataNascimento: '',
    celularPessoal: '',
    celularComercial: '',
    telefoneResidencial: '',
    emailPrincipal: '',
    emailSecundario: '',
    cep: '',
    rua: '',
    bairro: '',
    cidade: '',
    estado: '',
    compraConjunta: false,
    segundoCompradorNome: '',
    segundoCompradorCPF: '',
    segundoCompradorCelularPessoal: '',
    segundoCompradorCelularComercial: '',
    segundoCompradorTelefoneResidencial: '',
    segundoCompradorEmailPrincipal: '',
    segundoCompradorEmailSecundario: '',
    situacao_id: '',
    renda: '',
    saldoFGTS: '',
    valorEntrada: '',
    observacoesEntrada: '',
    observacoesAtendimento: ''
  });
  
  // Estados para formulário de construtor
  const [construtorFormData, setConstrutorFormData] = useState({
    nome: '',
    tipoDocumento: 'CPF',
    cpf_cnpj: '',
    tel_celular_principal: '',
    tel_celular_comercial: '',
    tel_comercial: '',
    email_corporativo: '',
    email_secundario: '',
    imoveis: [],
    obras: {
      empreiteiro: [],
      mestreObra: [],
      pedreiro: [],
      vigia: []
    }
  });
  const [imoveisList, setImoveisList] = useState([]);
  const [imoveisFiltrados, setImoveisFiltrados] = useState([]);
  const [pesquisaImovel, setPesquisaImovel] = useState('');
  const [activeObraTab, setActiveObraTab] = useState('empreiteiro');
  
  // Opções para dropdowns
  const opcoesAcessoMidia = ['Adesivo', 'ImóvelWeb'];
  const opcoesSituacao = [
    'Cliente de Fato',
    'Comprou com Terceiros'
  ];

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/admin/login');
      return;
    }

    loadDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);
  
  // Verificar aniversários quando clientes são carregados
  useEffect(() => {
    if (clientes.length > 0) {
      checkAniversarios(clientes);
    }
    
    // Verificar aniversários a cada hora
    const intervalAniversarios = setInterval(() => {
      if (clientes.length > 0) {
        checkAniversarios(clientes);
      }
    }, 3600000); // 1 hora
    
    return () => {
      clearInterval(intervalAniversarios);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientes]);
  
  // Verificar se há um imóvel para editar vindo de outra página
  useEffect(() => {
    if (location.state?.editImovel && imoveis.length > 0) {
      const imovelId = location.state.editImovel;
      const imovelParaEditar = imoveis.find(i => i.id === imovelId);
      if (imovelParaEditar) {
        handleEditImovel(imovelParaEditar);
        // Limpar o estado para evitar reabrir o modal
        navigate(location.pathname, { replace: true, state: { activeTab: 'imoveis' } });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imoveis, location.state]);

  const loadDashboard = async () => {
    try {
      setLoading(true);
      const [statsRes, recentRes] = await Promise.all([
        getDashboardStats(),
        getDashboardRecent()
      ]);
      setStats(statsRes.data);
      setRecent(recentRes.data);
    } catch (error) {
      console.error('Erro ao carregar dashboard:', error);
      if (error.response?.status === 401) {
        navigate('/admin/login');
      }
    } finally {
      setLoading(false);
    }
  };

  const loadImoveis = async () => {
    try {
      setLoadingTable(true);
      const response = await getImoveis({});
      setImoveis(response.data);
    } catch (error) {
      const msg = error.response?.data?.error || error.message;
      console.error('Erro ao carregar imóveis:', msg, error);
      alert(`Erro ao carregar imóveis: ${msg}`);
    } finally {
      setLoadingTable(false);
    }
  };

  const loadClientes = async () => {
    try {
      setLoadingTable(true);
      const response = await getClientes({});
      setClientes(response.data);
      checkAniversarios(response.data);
    } catch (error) {
      console.error('Erro ao carregar clientes:', error);
    } finally {
      setLoadingTable(false);
    }
  };

  // Verificar aniversários de clientes "Cliente de Fato"
  const checkAniversarios = (clientesList) => {
    const hoje = new Date();
    const diaHoje = hoje.getDate();
    const mesHoje = hoje.getMonth() + 1; // getMonth retorna 0-11
    
    const clientesAniversario = clientesList.filter(cliente => {
      if (cliente.situacao !== 'Cliente de Fato' || !cliente.dataNascimento) {
        return false;
      }
      
      try {
        const dataNasc = new Date(cliente.dataNascimento);
        const diaNasc = dataNasc.getDate();
        const mesNasc = dataNasc.getMonth() + 1;
        
        return diaNasc === diaHoje && mesNasc === mesHoje;
      } catch (error) {
        return false;
      }
    });
    
    if (clientesAniversario.length > 0) {
      clientesAniversario.forEach(cliente => {
        const notificationId = `aniversario-${cliente.id}-${diaHoje}-${mesHoje}`;
        // Verificar se já existe notificação para este cliente hoje
        const existingNotification = document.querySelector(`[data-notification-id="${notificationId}"]`);
        
        if (!existingNotification) {
          // Criar notificação
          const notification = document.createElement('div');
          notification.className = 'notification-birthday';
          notification.setAttribute('data-notification-id', notificationId);
          notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #ff6b6b;
            color: white;
            padding: 1rem 1.5rem;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            z-index: 10000;
            max-width: 400px;
            animation: slideIn 0.3s ease-out;
          `;
          notification.innerHTML = `
            <div style="display: flex; justify-content: space-between; align-items: start;">
              <div>
                <strong>🎉 Aniversário Hoje!</strong>
                <p style="margin: 0.5rem 0 0 0; font-size: 0.9rem;">
                  ${cliente.nome} está completando anos hoje!
                </p>
              </div>
              <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; color: white; font-size: 1.2rem; cursor: pointer; margin-left: 1rem;">×</button>
            </div>
          `;
          document.body.appendChild(notification);
          
          // Remover após 10 segundos
          setTimeout(() => {
            if (notification.parentElement) {
              notification.remove();
            }
          }, 10000);
        }
      });
    }
  };

  const loadConstrutores = async () => {
    try {
      setLoadingTable(true);
      const response = await getConstrutores();
      setConstrutores(response.data);
      setConstrutoresList(response.data);
    } catch (error) {
      console.error('Erro ao carregar construtores:', error);
    } finally {
      setLoadingTable(false);
    }
  };
  
  const loadTags = async () => {
    try {
      const response = await getTags();
      setTags(response.data);
    } catch (error) {
      console.error('Erro ao carregar tags:', error);
      // Fallback: buscar tags dos imóveis se a rota de tags não estiver disponível
      try {
        const imoveisResponse = await getImoveis({});
        const tagsUnicas = [...new Set(imoveisResponse.data.map(imovel => imovel.tag).filter(Boolean))];
        setTags(tagsUnicas);
      } catch (fallbackError) {
        console.error('Erro ao carregar tags dos imóveis:', fallbackError);
      }
    }
  };

  const loadSituacoes = async () => {
    try {
      const response = await getSituacoes();
      setSituacoes(response.data);
    } catch (error) {
      console.error('Erro ao carregar situações:', error);
    }
  };

  const loadStatusConstrucao = async () => {
    try {
      const response = await getStatusConstrucao();
      setStatusConstrucaoList(response.data);
    } catch (error) {
      console.error('Erro ao carregar status de construção:', error);
    }
  };

  const loadClientesSituacoes = async () => {
    try {
      const response = await getClientesSituacoes();
      setClientesSituacoes(response.data);
    } catch (error) {
      console.error('Erro ao carregar situações de clientes:', error);
    }
  };

  const loadTiposDocumento = async () => {
    try {
      const response = await getTiposDocumento();
      setTiposDocumento(response.data);
    } catch (error) {
      console.error('Erro ao carregar tipos de documento:', error);
    }
  };

  const loadTiposVinculo = async () => {
    try {
      const response = await getTiposVinculo();
      setTiposVinculo(response.data);
    } catch (error) {
      console.error('Erro ao carregar tipos de vínculo:', error);
    }
  };
  
  const loadImoveisList = async () => {
    try {
      const response = await getImoveis({});
      setImoveisList(response.data);
    } catch (error) {
      console.error('Erro ao carregar imóveis:', error);
    }
  };

  const loadAgendamentos = async () => {
    try {
      setLoadingTable(true);
      const response = await getAgendamentos({});
      // Converter data_visita e horario_visita em dataHora para compatibilidade
      const agendamentosFormatados = response.data.map(ag => {
        let dataHora = null;
        if (ag.data_visita && ag.horario_visita) {
          // Combinar data e horário: YYYY-MM-DD + HH:MM -> ISO string
          // Se horario_visita já tem segundos, não adicionar :00
          const horario = ag.horario_visita.includes(':') && ag.horario_visita.split(':').length === 2 
            ? `${ag.horario_visita}:00` 
            : ag.horario_visita;
          const dataHoraStr = `${ag.data_visita}T${horario}`;
          const dateObj = new Date(dataHoraStr);
          if (!isNaN(dateObj.getTime())) {
            dataHora = dateObj.toISOString();
          }
        } else if (ag.dataHora) {
          // Se já existe dataHora, validar antes de usar
          const dateObj = new Date(ag.dataHora);
          if (!isNaN(dateObj.getTime())) {
            dataHora = ag.dataHora;
          }
        }
        
        // Extrair nome do cliente - pode vir de pessoa_principal ou do próprio cliente
        let clienteNome = '';
        if (ag.cliente?.pessoa_principal?.nome) {
          clienteNome = ag.cliente.pessoa_principal.nome;
        } else if (ag.cliente?.nome) {
          clienteNome = ag.cliente.nome;
        } else if (ag.clienteNome) {
          clienteNome = ag.clienteNome;
        }
        
        return {
          ...ag,
          dataHora: dataHora,
          clienteNome: clienteNome,
          clienteId: ag.cliente_id || ag.clienteId || ag.cliente?.id,
          imovelId: ag.imovel_id || ag.imovelId || ag.imovel?.id,
          imovelCodigo: ag.imovel?.codigo || ag.imovelCodigo || '',
          imovelTipo: ag.imovel?.tipo || ag.imovelTipo || '',
          imovelBairro: ag.imovel?.bairro || ag.imovelBairro || '',
          imovelCidade: ag.imovel?.cidade || ag.imovelCidade || '',
          status: ag.status || 'agendado',
          observacoes: ag.observacoes || null
        };
      });
      setAgendamentos(agendamentosFormatados);
    } catch (error) {
      console.error('Erro ao carregar agendamentos:', error);
    } finally {
      setLoadingTable(false);
    }
  };

  const handleSaveAgendamento = async (data, id) => {
    try {
      if (id) {
        await updateAgendamento(id, data);
      } else {
        await createAgendamento(data);
      }
      // Recarregar agendamentos após salvar
      await loadAgendamentos();
    } catch (error) {
      console.error('Erro ao salvar agendamento:', error);
      const errorMessage = error.response?.data?.error || error.message || 'Erro ao salvar agendamento';
      alert(`Erro: ${errorMessage}`);
      throw error;
    }
  };

  const handleDeleteAgendamento = async (id) => {
    try {
      if (!id) {
        alert('ID do agendamento não fornecido');
        return;
      }
      console.log('Deletando agendamento com ID:', id, 'Tipo:', typeof id);
      await deleteAgendamento(id);
      await loadAgendamentos();
      alert('Agendamento deletado com sucesso');
    } catch (error) {
      console.error('Erro ao deletar agendamento:', error);
      console.error('ID tentado:', id);
      console.error('Resposta do servidor:', error.response?.data);
      const errorMessage = error.response?.data?.error || error.message || 'Erro ao deletar agendamento';
      alert(`Erro: ${errorMessage}`);
    }
  };

  useEffect(() => {
    if (activeTab === 'imoveis') {
      loadImoveis();
      loadTags();
      loadConstrutores();
    } else if (activeTab === 'clientes') {
      loadClientes();
    } else if (activeTab === 'construtores') {
      loadConstrutores();
      loadImoveisList();
    } else if (activeTab === 'agendamentos') {
      loadAgendamentos();
      loadClientes();
      loadImoveis();
    }
  }, [activeTab]);
  
  useEffect(() => {
    if (pesquisaImovel.length > 0) {
      const pesquisa = pesquisaImovel.toLowerCase();
      
      // Filtrar por todos os campos da tabela de imóveis (mesmo padrão da aba de clientes)
      const filtrados = imoveisList.filter(imovel => {
        // Campos da tabela: código, tipo, bairro, cidade
        const codigo = imovel.codigo?.toLowerCase() || '';
        const tipo = imovel.tipo?.toLowerCase() || '';
        const bairro = imovel.bairro?.toLowerCase() || '';
        const cidade = imovel.cidade?.toLowerCase() || '';
        const estado = imovel.estado?.toLowerCase() || '';
        const endereco = imovel.endereco?.toLowerCase() || '';
        
        // Verificar se a pesquisa corresponde a algum campo
        return codigo.includes(pesquisa) ||
               tipo.includes(pesquisa) ||
               bairro.includes(pesquisa) ||
               cidade.includes(pesquisa) ||
               estado.includes(pesquisa) ||
               endereco.includes(pesquisa) ||
               `${bairro}, ${cidade}`.includes(pesquisa) ||
               `${cidade}, ${estado}`.includes(pesquisa);
      });
      
      setImoveisFiltrados(filtrados.slice(0, 10));
    } else {
      setImoveisFiltrados([]);
    }
  }, [pesquisaImovel, imoveisList]);

  // Carregar tags quando o modal de imóvel for aberto
  useEffect(() => {
    if (showImovelModal) {
      loadTags();
      loadSituacoes();
      loadStatusConstrucao();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showImovelModal]);

  // Detectar alterações na unidade atual (para fluxo Avançar/Concluir)
  useEffect(() => {
    if (showImovelModal && unidadeAtual > 1 && totalImoveisCadastro > 1 && !editingImovel) {
      if (justLoadedNextUnitRef.current) {
        justLoadedNextUnitRef.current = false;
      } else {
        setUnidadeAtualAlterada(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imovelFormData, unidadeAtual, totalImoveisCadastro, editingImovel, showImovelModal]);

  // Carregar dados quando o modal de cliente for aberto
  useEffect(() => {
    if (showClienteModal) {
      loadClientesSituacoes();
      loadTiposDocumento();
      loadTiposVinculo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showClienteModal]);

  const handleDeleteImovel = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este imóvel?')) return;
    try {
      await deleteImovel(id);
      loadImoveis();
    } catch (error) {
      console.error('Erro ao excluir imóvel:', error);
      alert('Erro ao excluir imóvel');
    }
  };

  // Deletar todas as unidades com o mesmo código
  const handleDeleteTodasUnidades = async (codigo) => {
    if (!window.confirm(`Tem certeza que deseja excluir TODAS as unidades com o código "${codigo}"?`)) return;
    try {
      const imoveisComMesmoCodigo = imoveis.filter(i => i.codigo === codigo);
      await Promise.all(imoveisComMesmoCodigo.map(imovel => deleteImovel(imovel.id)));
      loadImoveis();
      alert(`Todas as unidades do código "${codigo}" foram excluídas com sucesso.`);
    } catch (error) {
      console.error('Erro ao excluir todas as unidades:', error);
      alert('Erro ao excluir todas as unidades');
    }
  };

  // buildImovelPayload - monta payload para API
  const buildImovelPayload = (formData, dadosBase, unidadeIndex) => {
    const toNullIfEmpty = (value) => (value && value.toString().trim() !== '') ? value : null;
    const precoNumero = formData.preco && formData.preco.trim() !== '' ? currencyToNumber(formData.preco) : null;
    const codigoBase = (formData.codigo || '').trim().replace(/-\d+$/, '') || formData.codigo;
    const codigo = unidadeIndex > 1 ? (codigoBase || formData.codigo) : formData.codigo;
    return {
      codigo,
      unidade: formData.unidade || (unidadeIndex > 1 ? String(unidadeIndex) : null),
      tipo: dadosBase.tipo || formData.tipo,
      cidade: dadosBase.cidade || formData.cidade,
      bairro: dadosBase.bairro || formData.bairro,
      estado: dadosBase.estado || formData.estado,
      cep: toNullIfEmpty(formData.cep),
      rua: dadosBase.rua || formData.rua,
      numero: toNullIfEmpty(formData.numero),
      preco: precoNumero,
      quartos: formData.quartos && formData.quartos.toString().trim() !== '' ? parseInt(formData.quartos) : null,
      banheiros: formData.banheiros && formData.banheiros.toString().trim() !== '' ? parseInt(formData.banheiros) : null,
      suites: formData.suites && formData.suites.toString().trim() !== '' ? parseInt(formData.suites) : null,
      lavabos: formData.lavabos && formData.lavabos.toString().trim() !== '' ? parseInt(formData.lavabos) : null,
      garagem: formData.garagem && formData.garagem.toString().trim() !== '' ? parseInt(formData.garagem) : null,
      area_construida: formData.areaConstruida && formData.areaConstruida.toString().trim() !== '' ? parseFloat(formData.areaConstruida) : null,
      area_externa: formData.areaExterna && formData.areaExterna.toString().trim() !== '' ? parseFloat(formData.areaExterna) : null,
      area_lote: formData.areaLote && formData.areaLote.toString().trim() !== '' ? parseFloat(formData.areaLote) : null,
      descricao: toNullIfEmpty(formData.descricao),
      detalhes: toNullIfEmpty(formData.detalhes),
      observacoes: toNullIfEmpty(formData.observacoes),
      situacao_id: formData.situacao_id ? parseInt(formData.situacao_id) : null,
      status_construcao_id: formData.status_construcao_id ? parseInt(formData.status_construcao_id) : null,
      fotos: (dadosBase.fotos && dadosBase.fotos.length > 0) ? dadosBase.fotos : (formData.fotos || []),
      tags: (dadosBase.tags && dadosBase.tags.length > 0) ? dadosBase.tags : (formData.tags || [])
    };
  };

  const handleAvançar = async (e) => {
    e.preventDefault();
    if (savingImovel) return;
    if (!imovelFormData.codigo?.trim()) {
      alert('Preencha o código da unidade.');
      return;
    }
    if (!imovelFormData.tipo) {
      alert('Selecione o tipo do imóvel.');
      return;
    }
    setSavingImovel(true);
    try {
      const dadosBase = unidadeAtual === 1 ? {} : (dadosBaseImovel || {});
      if (unidadeAtual === 1) {
        Object.assign(dadosBase, {
          tipo: imovelFormData.tipo,
          cidade: imovelFormData.cidade,
          bairro: imovelFormData.bairro,
          estado: imovelFormData.estado,
          rua: imovelFormData.rua,
          construtorId: imovelFormData.construtorId || null,
          tags: imovelFormData.tags,
          fotos: imovelFormData.fotos
        });
      }
      const data = buildImovelPayload(imovelFormData, dadosBase, unidadeAtual);
      const response = await createImovel(data);
      const createdId = response?.data?.id;
      if (createdId) {
        setUnidadesSalvasIds(prev => [...prev, createdId]);
      }
      setUnidadesPendentes(prev => [...prev, { formData: { ...imovelFormData }, alterada: unidadeAtualAlterada }]);
      if (unidadeAtual === 1) {
        setDadosBaseImovel({
          tipo: imovelFormData.tipo,
          cidade: imovelFormData.cidade,
          bairro: imovelFormData.bairro,
          estado: imovelFormData.estado,
          rua: imovelFormData.rua,
          construtorId: imovelFormData.construtorId || null,
          tags: imovelFormData.tags,
          fotos: imovelFormData.fotos
        });
      }
      const proximaUnidade = unidadeAtual + 1;
      setUnidadeAtual(proximaUnidade);
      setUnidadeAtualAlterada(false);
      justLoadedNextUnitRef.current = true;
      const codigoBase = imovelFormData.codigo?.trim().replace(/-\d+$/, '') || imovelFormData.codigo;
      setImovelFormData({
        ...imovelFormData,
        codigo: codigoBase ? `${codigoBase}-${proximaUnidade}` : '',
        preco: '',
        numero: '',
        areaConstruida: '',
        areaExterna: '',
        areaLote: '',
        quartos: '',
        banheiros: '',
        suites: '',
        lavabos: '',
        garagem: '',
        descricao: '',
        detalhes: '',
        observacoes: '',
        situacao_id: imovelFormData.situacao_id,
        status_construcao_id: imovelFormData.status_construcao_id
      });
      loadImoveis();
    } catch (error) {
      console.error('Erro ao salvar unidade:', error);
      const errorMessage = error.response?.data?.error || error.message || 'Erro ao salvar imóvel';
      alert(`Erro ao salvar imóvel: ${errorMessage}`);
    } finally {
      setSavingImovel(false);
    }
  };

  // Deletar uma unidade específica
  const handleDeleteUnidade = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta unidade?')) return;
    try {
      await deleteImovel(id);
      setShowImovelModal(false);
      resetImovelForm();
      loadImoveis();
      alert('Unidade excluída com sucesso.');
    } catch (error) {
      console.error('Erro ao excluir unidade:', error);
      alert('Erro ao excluir unidade');
    }
  };

  const handleDeleteCliente = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este cliente?')) return;
    try {
      await deleteCliente(id);
      loadClientes();
    } catch (error) {
      console.error('Erro ao excluir cliente:', error);
      alert('Erro ao excluir cliente');
    }
  };

  const handleDeleteConstrutor = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este construtor?')) return;
    try {
      await deleteConstrutor(id);
      loadConstrutores();
    } catch (error) {
      console.error('Erro ao excluir construtor:', error);
      alert('Erro ao excluir construtor');
    }
  };

  
  // Handlers para formulário de imóvel
  const handleImovelCEPChange = async (e) => {
    const cep = maskCEP(e.target.value);
    setImovelFormData({ ...imovelFormData, cep });
    
    if (cep.replace(/\D/g, '').length === 8) {
      try {
        const dados = await buscarCEP(cep);
        if (dados) {
          setImovelFormData(prev => ({
            ...prev,
            cep: dados.cep,
            rua: dados.rua,
            bairro: dados.bairro,
            cidade: dados.cidade,
            estado: dados.estado
          }));
        } else {
          // CEP não encontrado ou inválido - não fazer nada, deixar usuário preencher manualmente
          console.log('CEP não encontrado ou inválido');
        }
      } catch (error) {
        // Erro na busca - não quebrar a aplicação, apenas logar o erro
        console.error('Erro ao buscar CEP:', error);
      }
    }
  };
  
  const handleImovelPhotoUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    
    setUploadingPhotos(true);
    try {
      // Converter arquivos para base64 para persistir no estado
      const newPhotos = await Promise.all(
        files.map(file => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
        })
      );
      
      setImovelFormData(prev => ({
        ...prev,
        fotos: [...prev.fotos, ...newPhotos]
      }));
    } catch (error) {
      console.error('Erro ao fazer upload de fotos:', error);
      alert('Erro ao fazer upload de fotos');
    } finally {
      setUploadingPhotos(false);
    }
  };
  
  const removeImovelPhoto = (index) => {
    setImovelFormData(prev => {
      const newFotos = prev.fotos.filter((_, i) => i !== index);
      // Revogar blob URL se existir antes de remover
      const fotoRemovida = prev.fotos[index];
      if (fotoRemovida && fotoRemovida.startsWith('blob:')) {
        try {
          URL.revokeObjectURL(fotoRemovida);
        } catch (e) {
          // Ignorar erros ao revogar URL
        }
      }
      return {
        ...prev,
        fotos: newFotos
      };
    });
  };
  
  const moveImovelPhoto = (index, direction) => {
    setImovelFormData(prev => {
      const newFotos = [...prev.fotos];
      const newIndex = direction === 'up' ? index - 1 : index + 1;
      if (newIndex >= 0 && newIndex < newFotos.length) {
        [newFotos[index], newFotos[newIndex]] = [newFotos[newIndex], newFotos[index]];
        return {
          ...prev,
          fotos: newFotos
        };
      }
      return prev;
    });
  };
  
  const handleDragStart = (e, index) => {
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', index);
    e.dataTransfer.setData('index', index);
  };
  
  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };
  
  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = parseInt(e.dataTransfer.getData('index'));
    if (dragIndex === dropIndex) return;
    
    setImovelFormData(prev => {
      const newFotos = [...prev.fotos];
      const [removed] = newFotos.splice(dragIndex, 1);
      newFotos.splice(dropIndex, 0, removed);
      return {
        ...prev,
        fotos: newFotos
      };
    });
  };
  
  const handleEditImovel = async (imovel) => {
    setEditingImovel(imovel);
    // Preencher formulário com dados do imóvel
    setImovelFormData({
      codigo: imovel.codigo || '',
      tipo: imovel.tipo || 'Apartamento',
      preco: imovel.preco ? maskCurrency(imovel.preco) : '',
      areaConstruida: imovel.area_construida?.toString() || '',
      areaExterna: imovel.area_externa?.toString() || '',
      areaLote: imovel.area_lote?.toString() || '',
      possuiMultiplasUnidades: imovel.possuiMultiplasUnidades || false,
      totalUnidades: imovel.totalUnidades || '',
      unidadesDisponiveis: imovel.unidadesDisponiveis || '',
      unidadesReservadas: imovel.unidadesReservadas || '',
      unidadesVendidas: imovel.unidadesVendidas || '',
      cep: imovel.cep || '',
      rua: imovel.rua || '',
      numero: imovel.numero || '',
      bairro: imovel.bairro || '',
      cidade: imovel.cidade || '',
      estado: imovel.estado || 'MG',
      quartos: imovel.quartos?.toString() || '',
      banheiros: imovel.banheiros?.toString() || '',
      suites: imovel.suites?.toString() || '',
      lavabos: imovel.lavabos?.toString() || '',
      garagem: imovel.garagem?.toString() || '',
      descricao: imovel.descricao || '',
      detalhes: imovel.detalhes || '',
      observacoes: imovel.observacoes || '',
      construtorId: imovel.construtorId || '',
      situacao_id: imovel.situacao_id?.toString() || '',
      status_construcao_id: imovel.status_construcao_id?.toString() || '',
      disponivel: imovel.disponivel !== undefined ? imovel.disponivel : true,
      areaPrivativa: imovel.areaPrivativa !== undefined ? imovel.areaPrivativa : false,
      tags: imovel.tags && Array.isArray(imovel.tags) ? imovel.tags : (imovel.tag ? [imovel.tag] : []),
      fotos: imovel.fotos || []
    });
    loadTags();
    setShowImovelModal(true);
  };

  const handleSubmitImovel = async (e) => {
    e.preventDefault();
    if (savingImovel) return; // Prevenir cliques duplos
    
    // Validar código duplicado apenas ao criar novo imóvel (não ao editar)
    if (!editingImovel && imovelFormData.codigo) {
      const imoveisComMesmoCodigo = imoveis.filter(i => i.codigo === imovelFormData.codigo);
      if (imoveisComMesmoCodigo.length > 0) {
        const confirmar = window.confirm(
          `Já existem ${imoveisComMesmoCodigo.length} imóvel(is) cadastrado(s) com o código "${imovelFormData.codigo}".\n\n` +
          `Deseja realmente continuar com o cadastro usando este código?`
        );
        if (!confirmar) {
          return;
        }
      }
    }
    
    setSavingImovel(true);
    try {
      const totalImoveis = editingImovel ? 1 : (totalImoveisCadastro > 1 ? totalImoveisCadastro : (imovelFormData.totalImoveis || 1));
      const unidadeAtualNum = editingImovel ? 1 : unidadeAtual;
      
      // Se for o primeiro imóvel de múltiplos, salvar dados base
      if (!editingImovel && unidadeAtualNum === 1 && totalImoveis > 1) {
        const dadosBase = {
          tipo: imovelFormData.tipo,
          cidade: imovelFormData.cidade,
          bairro: imovelFormData.bairro,
          estado: imovelFormData.estado,
          rua: imovelFormData.rua,
          construtorId: imovelFormData.construtorId || null,
          tags: imovelFormData.tags,
          fotos: imovelFormData.fotos
        };
        setDadosBaseImovel(dadosBase);
        setTotalImoveisCadastro(totalImoveis);
      }
      
      // Permitir múltiplos imóveis com o mesmo código (unidades)
      
      // Usar dados base se estiver cadastrando múltiplos imóveis
      const dadosBase = dadosBaseImovel || {};
      
      // Garantir que fotos seja sempre um array
      let fotosArray = dadosBase.fotos || imovelFormData.fotos || [];
      if (typeof fotosArray === 'string') {
        try {
          fotosArray = JSON.parse(fotosArray);
        } catch (e) {
          fotosArray = [];
        }
      }
      if (!Array.isArray(fotosArray)) {
        fotosArray = [];
      }
      
      // Filtrar URLs blob inválidas e separar fotos novas (base64) das já salvas (URLs)
      const fotosNovas = [];
      const fotosExistentes = [];
      
      fotosArray.forEach(foto => {
        if (!foto) return;
        
        // Remover blob URLs inválidas
        if (foto.startsWith('blob:')) {
          return; // Ignorar blob URLs
        }
        
        // Se for base64 (foto nova), adicionar às novas
        if (foto.startsWith('data:image/')) {
          fotosNovas.push(foto);
        } else {
          // Se for URL (foto já salva no servidor), adicionar às existentes
          fotosExistentes.push(foto);
        }
      });
      
      // Limitar tamanho: se houver muitas fotos base64, avisar o usuário
      // Base64 aumenta muito o tamanho do payload (cada foto pode ter 1-5MB em base64)
      // Aumentado o limite para 10 fotos por vez com melhor tratamento de erros
      if (fotosNovas.length > 10) {
        const continuar = window.confirm(
          `Você está tentando salvar ${fotosNovas.length} fotos novas. Isso pode causar erro de tamanho.\n\n` +
          `Recomendamos fazer upload de no máximo 10 fotos por vez.\n\n` +
          `Deseja continuar mesmo assim?`
        );
        if (!continuar) {
          return;
        }
      }
      
      // Otimizar fotos base64: reduzir qualidade se necessário
      if (fotosNovas.length > 5) {
        console.log(`Processando ${fotosNovas.length} fotos novas. Isso pode levar alguns segundos...`);
      }
      
      // Combinar fotos existentes com novas
      fotosArray = [...fotosExistentes, ...fotosNovas];
      
      // Converter preço de string formatada para número
      const precoNumero = imovelFormData.preco && imovelFormData.preco.trim() !== '' ? currencyToNumber(imovelFormData.preco) : null;
      
      // Função auxiliar para converter string vazia em null
      const toNullIfEmpty = (value) => (value && value.toString().trim() !== '') ? value : null;
      
      const data = {
        codigo: imovelFormData.codigo,
        unidade: imovelFormData.unidade || null,
        tipo: dadosBase.tipo || imovelFormData.tipo,
        cidade: dadosBase.cidade || imovelFormData.cidade,
        bairro: dadosBase.bairro || imovelFormData.bairro,
        estado: dadosBase.estado || imovelFormData.estado,
        cep: toNullIfEmpty(imovelFormData.cep),
        rua: toNullIfEmpty(dadosBase.rua || imovelFormData.rua),
        numero: toNullIfEmpty(imovelFormData.numero),
        preco: precoNumero,
        quartos: imovelFormData.quartos && imovelFormData.quartos.toString().trim() !== '' ? parseInt(imovelFormData.quartos) : null,
        banheiros: imovelFormData.banheiros && imovelFormData.banheiros.toString().trim() !== '' ? parseInt(imovelFormData.banheiros) : null,
        suites: imovelFormData.suites && imovelFormData.suites.toString().trim() !== '' ? parseInt(imovelFormData.suites) : null,
        lavabos: imovelFormData.lavabos && imovelFormData.lavabos.toString().trim() !== '' ? parseInt(imovelFormData.lavabos) : null,
        garagem: imovelFormData.garagem && imovelFormData.garagem.toString().trim() !== '' ? parseInt(imovelFormData.garagem) : null,
        area_construida: imovelFormData.areaConstruida && imovelFormData.areaConstruida.toString().trim() !== '' ? parseFloat(imovelFormData.areaConstruida) : null,
        area_externa: imovelFormData.areaExterna && imovelFormData.areaExterna.toString().trim() !== '' ? parseFloat(imovelFormData.areaExterna) : null,
        area_lote: imovelFormData.areaLote && imovelFormData.areaLote.toString().trim() !== '' ? parseFloat(imovelFormData.areaLote) : null,
        descricao: toNullIfEmpty(imovelFormData.descricao),
        detalhes: toNullIfEmpty(imovelFormData.detalhes),
        observacoes: toNullIfEmpty(imovelFormData.observacoes),
        situacao_id: imovelFormData.situacao_id ? parseInt(imovelFormData.situacao_id) : null,
        status_construcao_id: imovelFormData.status_construcao_id ? parseInt(imovelFormData.status_construcao_id) : null,
        fotos: fotosArray,
        tags: (dadosBase.tags && dadosBase.tags.length > 0) ? dadosBase.tags : (imovelFormData.tags && imovelFormData.tags.length > 0 ? imovelFormData.tags : [])
      };
      
      if (editingImovel) {
        await updateImovel(editingImovel.id, data);
        setShowImovelModal(false);
        setEditingImovel(null);
        resetImovelForm();
      } else if (totalImoveis > 1) {
        // Fluxo Concluir: salvar unidades restantes (não salvas via Avançar)
        const totalSalvos = unidadesSalvasIds.length;
        const primeiraUnidade = unidadesPendentes[0]?.formData || imovelFormData;
        const codigoBase = (primeiraUnidade.codigo || '').trim().replace(/-\d+$/, '') || 'COD';

        for (let i = 0; i < totalImoveis; i++) {
          if (i < totalSalvos) continue;

          let fd;
          if (i < unidadesPendentes.length) {
            const { formData, alterada } = unidadesPendentes[i];
            fd = alterada ? formData : { ...primeiraUnidade, codigo: `${codigoBase}-${i + 1}` };
          } else if (i === unidadeAtual - 1) {
            fd = imovelFormData;
          } else {
            fd = { ...primeiraUnidade, codigo: `${codigoBase}-${i + 1}` };
          }

          const payload = buildImovelPayload(fd, dadosBaseImovel || {}, i + 1);
          await createImovel(payload);
        }

        alert(`Todos os ${totalImoveis} imóveis foram cadastrados com sucesso!`);
        setShowImovelModal(false);
        setEditingImovel(null);
        resetImovelForm();
      } else {
        // Salvar um único imóvel
        await createImovel(data);
        setShowImovelModal(false);
        setEditingImovel(null);
        resetImovelForm();
      }
      
      loadImoveis();
      loadTags();
    } catch (error) {
      console.error('Erro ao salvar imóvel:', error);
      const errorMessage = error.response?.data?.error || error.message || 'Erro ao salvar imóvel';
      alert(`Erro ao salvar imóvel: ${errorMessage}`);
    } finally {
      setSavingImovel(false);
    }
  };
  
  // Função para obter telefone com prioridade e formatar
  const getTelefoneCliente = (cliente) => {
    // Buscar telefone dos campos individuais com prioridade
    const telefone = cliente.telefone || cliente.celularPessoal || cliente.celularComercial || cliente.telefoneResidencial;
    return formatPhoneDisplay(telefone);
  };
  
  const getTelefoneConstrutor = (construtor) => {
    // Buscar telefone dos campos mapeados do backend ou campos diretos do banco
    const telefone = construtor.tel_celular_principal || construtor.celular_pessoal || 
                     construtor.tel_celular_comercial || construtor.celular_coorporativo || 
                     construtor.tel_comercial || construtor.telefone_residencial;
    return formatPhoneDisplay(telefone);
  };
  
  // Função para formatar CPF/CNPJ de cliente
  const formatCPFCNPJCliente = (cliente) => {
    return formatCPFCNPJDisplay(cliente.cpfCnpj);
  };
  
  // Função para formatar CPF/CNPJ de construtor
  const formatCPFCNPJConstrutor = (construtor) => {
    return formatCPFCNPJDisplay(construtor.cpf_cnpj);
  };
  
  // Funções de filtro para pesquisa
  const filtrarImoveis = (imoveis) => {
    if (!pesquisaImoveis) return imoveis;
    const pesquisa = pesquisaImoveis.toLowerCase();
    return imoveis.filter(imovel => 
      imovel.codigo?.toLowerCase().includes(pesquisa) ||
      imovel.tipo?.toLowerCase().includes(pesquisa) ||
      imovel.bairro?.toLowerCase().includes(pesquisa) ||
      imovel.cidade?.toLowerCase().includes(pesquisa) ||
      imovel.estado?.toLowerCase().includes(pesquisa) ||
      imovel.preco?.toString().includes(pesquisa)
    );
  };
  
  const filtrarClientes = (clientes) => {
    if (!pesquisaClientes) return clientes;
    const pesquisa = pesquisaClientes.toLowerCase();
    return clientes.filter(cliente => 
      cliente.nome?.toLowerCase().includes(pesquisa) ||
      cliente.cpfCnpj?.toLowerCase().includes(pesquisa) ||
      cliente.email?.toLowerCase().includes(pesquisa) ||
      cliente.celularPessoal?.toLowerCase().includes(pesquisa) ||
      cliente.celularComercial?.toLowerCase().includes(pesquisa) ||
      cliente.telefoneResidencial?.toLowerCase().includes(pesquisa) ||
      cliente.situacao?.toLowerCase().includes(pesquisa)
    );
  };
  
  const filtrarConstrutores = (construtores) => {
    if (!pesquisaConstrutores) return construtores;
    const pesquisa = pesquisaConstrutores.toLowerCase();
    return construtores.filter(construtor => 
      construtor.nome?.toLowerCase().includes(pesquisa) ||
      construtor.cpf_cnpj?.toLowerCase().includes(pesquisa) ||
      construtor.email_corporativo?.toLowerCase().includes(pesquisa) ||
      construtor.email_secundario?.toLowerCase().includes(pesquisa) ||
      construtor.tel_celular_principal?.toLowerCase().includes(pesquisa) ||
      construtor.tel_celular_comercial?.toLowerCase().includes(pesquisa) ||
      construtor.tel_comercial?.toLowerCase().includes(pesquisa)
    );
  };
  
  // Função para agrupar imóveis por código
  const agruparImoveisPorCodigo = (imoveis) => {
    const agrupados = {};
    imoveis.forEach(imovel => {
      if (!agrupados[imovel.codigo]) {
        agrupados[imovel.codigo] = [];
      }
      agrupados[imovel.codigo].push(imovel);
    });
    return agrupados;
  };

  // Funções para obter dados paginados
  const getClientesPaginados = (clientesFiltrados) => {
    const startIndex = (pageClientes - 1) * itemsPerPageClientes;
    const endIndex = startIndex + itemsPerPageClientes;
    return clientesFiltrados.slice(startIndex, endIndex);
  };

  const getImoveisPaginados = (imoveisFiltrados) => {
    const startIndex = (pageImoveis - 1) * itemsPerPageImoveis;
    const endIndex = startIndex + itemsPerPageImoveis;
    return imoveisFiltrados.slice(startIndex, endIndex);
  };

  const getConstrutoresPaginados = (construtoresFiltrados) => {
    const startIndex = (pageConstrutores - 1) * itemsPerPageConstrutores;
    const endIndex = startIndex + itemsPerPageConstrutores;
    return construtoresFiltrados.slice(startIndex, endIndex);
  };
  
  const resetImovelForm = () => {
    setEditingImovel(null);
    setUnidadeAtual(1);
    setTotalImoveisCadastro(1);
    setDadosBaseImovel(null);
    setUnidadesPendentes([]);
    setUnidadesSalvasIds([]);
    setUnidadeAtualAlterada(false);
    setImovelFormData({
      codigo: '',
      tipo: '',
      preco: '',
      totalImoveis: 1,
      areaConstruida: '',
      areaExterna: '',
      areaLote: '',
      possuiMultiplasUnidades: false,
      totalUnidades: '',
      unidadesDisponiveis: '',
      unidadesReservadas: '',
      unidadesVendidas: '',
      cep: '',
      rua: '',
      numero: '',
      bairro: '',
      cidade: '',
      estado: 'MG',
      quartos: '',
      banheiros: '',
      suites: '',
      lavabos: '',
      garagem: '',
      detalhes: '',
      observacoes: '',
      construtorId: '',
      situacao_id: '',
      status_construcao_id: '',
      disponivel: true,
      tags: [],
      fotos: []
    });
  };
  
  // Handlers para formulário de cliente
  const handleClienteCEPChange = async (e) => {
    const cep = maskCEP(e.target.value);
    setClienteFormData({ ...clienteFormData, cep });
    
    if (cep.replace(/\D/g, '').length === 8) {
      try {
        const dados = await buscarCEP(cep);
        if (dados) {
          setClienteFormData(prev => ({
            ...prev,
            cep: dados.cep,
            rua: dados.rua,
            bairro: dados.bairro,
            cidade: dados.cidade,
            estado: dados.estado
          }));
        } else {
          // CEP não encontrado ou inválido - não fazer nada, deixar usuário preencher manualmente
          console.log('CEP não encontrado ou inválido');
        }
      } catch (error) {
        // Erro na busca - não quebrar a aplicação, apenas logar o erro
        console.error('Erro ao buscar CEP:', error);
      }
    }
  };
  
  const handleEditCliente = async (cliente) => {
    setEditingCliente(cliente);
    
    // Buscar pessoa principal do array de pessoas
    const pessoaPrincipal = cliente.pessoas?.find(p => p.tipo_vinculo_nome === 'PRINCIPAL') || cliente.pessoas?.[0] || null;
    const pessoaSegunda = cliente.pessoas?.find(p => p.tipo_vinculo_nome === 'SEGUNDO') || null;
    
    // Preencher formulário com dados do cliente e pessoa principal
    setClienteFormData({
      nome: pessoaPrincipal?.nome || cliente.nome || '',
      tipoDocumento: pessoaPrincipal?.tipo_documento_nome || (cliente.cpfCnpj?.length === 14 ? 'CPF' : cliente.cpfCnpj?.length === 18 ? 'CNPJ' : 'CPF'),
      cpfCnpj: pessoaPrincipal?.cpf_cnpj || cliente.cpfCnpj || '',
      acessoMidia: cliente.acessoMidia || '',
      dataNascimento: pessoaPrincipal?.data_nascimento || cliente.dataNascimento || '',
      celularPessoal: pessoaPrincipal?.celular_pessoal || cliente.celularPessoal || '',
      celularComercial: pessoaPrincipal?.celular_coorporativo || cliente.celularComercial || '',
      telefoneResidencial: pessoaPrincipal?.telefone_residencial || cliente.telefoneResidencial || '',
      emailPrincipal: pessoaPrincipal?.email_principal || cliente.emailPrincipal || cliente.email || '',
      emailSecundario: pessoaPrincipal?.email_secundario || cliente.emailSecundario || '',
      cep: cliente.cep || '',
      rua: cliente.rua || '',
      bairro: cliente.bairro || '',
      cidade: cliente.cidade || '',
      estado: cliente.estado || '',
      compraConjunta: pessoaSegunda ? true : false,
      segundoCompradorNome: pessoaSegunda?.nome || '',
      segundoCompradorCPF: pessoaSegunda?.cpf_cnpj || '',
      segundoCompradorCelularPessoal: pessoaSegunda?.celular_pessoal || '',
      segundoCompradorCelularComercial: pessoaSegunda?.celular_coorporativo || '',
      segundoCompradorTelefoneResidencial: pessoaSegunda?.telefone_residencial || '',
      segundoCompradorEmailPrincipal: pessoaSegunda?.email_principal || '',
      segundoCompradorEmailSecundario: pessoaSegunda?.email_secundario || '',
      situacao_id: cliente.situacao_id || '',
      renda: cliente.renda ? maskCurrency(cliente.renda) : '',
      saldoFGTS: cliente.saldoFGTS ? maskCurrency(cliente.saldoFGTS) : '',
      valorEntrada: cliente.valorEntrada ? maskCurrency(cliente.valorEntrada) : '',
      observacoesEntrada: cliente.observacoes_acesso || '',
      observacoesAtendimento: cliente.observacoes_atendimento || ''
    });
    // Carregar imóveis relacionados se estiver editando
    if (cliente.id) {
      loadImoveisRelacionadosCliente(cliente.id);
    }
    
    setClienteModalTab('cliente');
    setShowClienteModal(true);
  };
  
  // Carregar imóveis relacionados ao cliente
  const loadImoveisRelacionadosCliente = async (clienteId) => {
    try {
      setLoadingImoveisCliente(true);
      const response = await getCliente(clienteId);
      if (response.data.imoveis) {
        setImoveisRelacionadosCliente(response.data.imoveis);
      }
    } catch (error) {
      console.error('Erro ao carregar imóveis relacionados:', error);
    } finally {
      setLoadingImoveisCliente(false);
    }
  };
  
  // Buscar imóveis para relacionar
  const buscarImoveisParaCliente = async () => {
    if (!pesquisaImovelCliente.trim()) {
      setImoveisDisponiveis([]);
      return;
    }
    
    try {
      setLoadingImoveisCliente(true);
      // Buscar todos os imóveis disponíveis
      const response = await getImoveis({
        disponivel: 'true'
      });
      
      const pesquisa = pesquisaImovelCliente.toLowerCase();
      
      // Filtrar por todos os campos da tabela de imóveis
      const filtrados = response.data.filter(imovel => {
        // Campos da tabela: código, tipo, bairro, cidade
        const codigo = imovel.codigo?.toLowerCase() || '';
        const tipo = imovel.tipo?.toLowerCase() || '';
        const bairro = imovel.bairro?.toLowerCase() || '';
        const cidade = imovel.cidade?.toLowerCase() || '';
        const estado = imovel.estado?.toLowerCase() || '';
        const endereco = imovel.endereco?.toLowerCase() || '';
        
        // Verificar se a pesquisa corresponde a algum campo
        return codigo.includes(pesquisa) ||
               tipo.includes(pesquisa) ||
               bairro.includes(pesquisa) ||
               cidade.includes(pesquisa) ||
               estado.includes(pesquisa) ||
               endereco.includes(pesquisa) ||
               `${bairro}, ${cidade}`.includes(pesquisa) ||
               `${cidade}, ${estado}`.includes(pesquisa);
      });
      
      setImoveisDisponiveis(filtrados);
    } catch (error) {
      console.error('Erro ao buscar imóveis:', error);
      setImoveisDisponiveis([]);
    } finally {
      setLoadingImoveisCliente(false);
    }
  };
  
  // Adicionar imóvel ao cliente
  const handleAdicionarImovelCliente = async (imovelId) => {
    if (!editingCliente?.id) {
      alert('Salve o cliente primeiro antes de adicionar imóveis');
      return;
    }
    
    try {
      await adicionarImovelCliente(editingCliente.id, imovelId, 'interesse', '');
      await loadImoveisRelacionadosCliente(editingCliente.id);
      setPesquisaImovelCliente('');
      setImoveisDisponiveis([]);
      alert('Imóvel adicionado com sucesso!');
    } catch (error) {
      console.error('Erro ao adicionar imóvel:', error);
      alert(error.response?.data?.error || 'Erro ao adicionar imóvel');
    }
  };
  
  // Remover imóvel do cliente
  const handleRemoverImovelCliente = async (imovelId) => {
    if (!editingCliente?.id) return;
    
    if (!window.confirm('Deseja realmente remover este imóvel?')) return;
    
    try {
      await removerImovelCliente(editingCliente.id, imovelId);
      await loadImoveisRelacionadosCliente(editingCliente.id);
      alert('Imóvel removido com sucesso!');
    } catch (error) {
      console.error('Erro ao remover imóvel:', error);
      alert('Erro ao remover imóvel');
    }
  };
  
  // useEffect para buscar imóveis quando pesquisa mudar
  useEffect(() => {
    const timer = setTimeout(() => {
      if (pesquisaImovelCliente && clienteModalTab === 'imoveis') {
        buscarImoveisParaCliente();
      }
    }, 500);
    
    return () => clearTimeout(timer);
  }, [pesquisaImovelCliente, clienteModalTab]);

  // Função auxiliar para validar e montar dados do cliente
  const validarEMontarDadosCliente = () => {
    const camposFaltando = [];

    // Validar campos obrigatórios
    if (!clienteFormData.situacao_id) {
      camposFaltando.push('Situação');
    }

    if (!clienteFormData.nome || clienteFormData.nome.trim() === '') {
      camposFaltando.push('Nome');
    }

    if (camposFaltando.length > 0) {
      alert(`Os seguintes campos são obrigatórios e não foram preenchidos:\n\n${camposFaltando.join('\n')}`);
      return null;
    }

    // Encontrar tipo de documento
    const tipoDocCPF = tiposDocumento.find(td => td.nome === 'CPF');
    const tipoDocCNPJ = tiposDocumento.find(td => td.nome === 'CNPJ');
    const tipoDocId = clienteFormData.tipoDocumento === 'CPF' 
      ? (tipoDocCPF?.id || null) 
      : (tipoDocCNPJ?.id || null);

    // Encontrar tipos de vínculo
    const tipoVinculoPrincipal = tiposVinculo.find(tv => tv.nome === 'PRINCIPAL');
    const tipoVinculoSegundo = tiposVinculo.find(tv => tv.nome === 'SEGUNDO');

    if (!tipoVinculoPrincipal) {
      alert('Erro: Tipo de vínculo PRINCIPAL não encontrado');
      return null;
    }

    // Montar array de pessoas
    const pessoas = [];
    
    // Pessoa principal
    pessoas.push({
      nome: clienteFormData.nome,
      tipo_documento_id: tipoDocId,
      cpf_cnpj: clienteFormData.cpfCnpj || null,
      data_nascimento: clienteFormData.dataNascimento || null,
      celular_pessoal: clienteFormData.celularPessoal || null,
      celular_coorporativo: clienteFormData.celularComercial || null,
      telefone_residencial: clienteFormData.telefoneResidencial || null,
      email_principal: clienteFormData.emailPrincipal || null,
      email_secundario: clienteFormData.emailSecundario || null,
      tipo_vinculo_id: tipoVinculoPrincipal.id
    });

    // Segunda pessoa (se compra conjunta)
    if (clienteFormData.compraConjunta && clienteFormData.segundoCompradorNome && clienteFormData.segundoCompradorNome.trim() !== '') {
      if (!tipoVinculoSegundo) {
        alert('Erro: Tipo de vínculo SEGUNDO não encontrado');
        return null;
      }

      const tipoDocSegundoCPF = tiposDocumento.find(td => td.nome === 'CPF');
      pessoas.push({
        nome: clienteFormData.segundoCompradorNome,
        tipo_documento_id: tipoDocSegundoCPF?.id || null,
        cpf_cnpj: clienteFormData.segundoCompradorCPF || null,
        data_nascimento: null,
        celular_pessoal: clienteFormData.segundoCompradorCelularPessoal || null,
        celular_coorporativo: clienteFormData.segundoCompradorCelularComercial || null,
        telefone_residencial: clienteFormData.segundoCompradorTelefoneResidencial || null,
        email_principal: clienteFormData.segundoCompradorEmailPrincipal || null,
        email_secundario: clienteFormData.segundoCompradorEmailSecundario || null,
        tipo_vinculo_id: tipoVinculoSegundo.id
      });
    }

    const data = {
      situacao_id: parseInt(clienteFormData.situacao_id),
      cep: clienteFormData.cep || null,
      rua: clienteFormData.rua || null,
      numero: null,
      bairro: clienteFormData.bairro || null,
      cidade: clienteFormData.cidade || null,
      estado: clienteFormData.estado || 'MG',
      renda: clienteFormData.renda ? currencyToNumber(clienteFormData.renda) : null,
      saldo_fgts: clienteFormData.saldoFGTS ? currencyToNumber(clienteFormData.saldoFGTS) : null,
      valor_entrada: clienteFormData.valorEntrada ? currencyToNumber(clienteFormData.valorEntrada) : null,
      observacoes_acesso: clienteFormData.observacoesEntrada || null,
      observacoes_atendimento: clienteFormData.observacoesAtendimento || null,
      pessoas: pessoas
    };

    return data;
  };

  const handleSubmitCliente = async (e) => {
    e.preventDefault();
    if (savingCliente) return; // Prevenir cliques duplos
    setSavingCliente(true);
    try {
      const data = validarEMontarDadosCliente();
      if (!data) {
        return; // Validação falhou, mensagem já foi exibida
      }
      
      let clienteSalvo;
      if (editingCliente) {
        await updateCliente(editingCliente.id, data);
        clienteSalvo = editingCliente;
      } else {
        const response = await createCliente(data);
        clienteSalvo = response.data;
        // Atualizar editingCliente com o cliente recém-criado para permitir adicionar imóveis
        setEditingCliente(clienteSalvo);
        // Carregar imóveis relacionados (vazio inicialmente)
        setImoveisRelacionadosCliente([]);
      }
      
      // Se estiver na aba de imóveis, manter o modal aberto e mudar para a aba de imóveis
      if (clienteModalTab === 'imoveis') {
        alert('Cliente salvo com sucesso! Agora você pode adicionar imóveis desejados.');
        loadClientes();
        return; // Não fecha o modal
      }
      
      // Se não estiver na aba de imóveis, fechar o modal normalmente
      setShowClienteModal(false);
      setEditingCliente(null);
      resetClienteForm();
      loadClientes();
    } catch (error) {
      console.error('Erro ao salvar cliente:', error);
      const errorMessage = error.response?.data?.error || 'Erro ao salvar cliente';
      alert(errorMessage);
    }
  };
  
  const resetClienteForm = () => {
    setEditingCliente(null);
    setClienteModalTab('cliente');
    setPesquisaImovelCliente('');
    setImoveisDisponiveis([]);
    setImoveisRelacionadosCliente([]);
    setClienteFormData({
      nome: '',
      tipoDocumento: 'CPF',
      cpfCnpj: '',
      acessoMidia: '',
      dataNascimento: '',
      celularPessoal: '',
      celularComercial: '',
      telefoneResidencial: '',
      emailPrincipal: '',
      emailSecundario: '',
      cep: '',
      rua: '',
      bairro: '',
      cidade: '',
      estado: '',
      compraConjunta: false,
      segundoCompradorNome: '',
      segundoCompradorCPF: '',
      segundoCompradorCelularPessoal: '',
      segundoCompradorCelularComercial: '',
      segundoCompradorTelefoneResidencial: '',
      segundoCompradorEmailPrincipal: '',
      segundoCompradorEmailSecundario: '',
      situacao_id: '',
      renda: '',
      saldoFGTS: '',
      valorEntrada: '',
      observacoesEntrada: '',
      observacoesAtendimento: ''
    });
  };
  
  // Handlers para formulário de construtor
  const adicionarObra = (tipo) => {
    const nome = document.getElementById(`obra-${tipo}-nome`)?.value;
    const telefone = document.getElementById(`obra-${tipo}-telefone`)?.value;
    
    if (!nome || !telefone) {
      alert('Preencha nome e telefone');
      return;
    }
    
    setConstrutorFormData(prev => {
      // Garantir que obras existe e que cada tipo é um array
      const obrasAtual = prev.obras || {
        empreiteiro: [],
        mestreObra: [],
        pedreiro: [],
        vigia: []
      };
      
      return {
        ...prev,
        obras: {
          ...obrasAtual,
          [tipo]: [...(Array.isArray(obrasAtual[tipo]) ? obrasAtual[tipo] : []), { nome, telefone }]
        }
      };
    });
    
    const nomeInput = document.getElementById(`obra-${tipo}-nome`);
    const telefoneInput = document.getElementById(`obra-${tipo}-telefone`);
    if (nomeInput) nomeInput.value = '';
    if (telefoneInput) telefoneInput.value = '';
  };
  
  const removerObra = (tipo, index) => {
    setConstrutorFormData(prev => {
      // Garantir que obras existe e que cada tipo é um array
      const obrasAtual = prev.obras || {
        empreiteiro: [],
        mestreObra: [],
        pedreiro: [],
        vigia: []
      };
      
      return {
        ...prev,
        obras: {
          ...obrasAtual,
          [tipo]: Array.isArray(obrasAtual[tipo]) ? obrasAtual[tipo].filter((_, i) => i !== index) : []
        }
      };
    });
  };
  
  // Buscar imóveis para relacionar ao construtor
  const buscarImoveisParaConstrutor = async () => {
    if (!pesquisaImovelConstrutor.trim()) {
      setImoveisDisponiveisConstrutor([]);
      return;
    }
    
    try {
      setLoadingImoveisConstrutor(true);
      // Buscar todos os imóveis disponíveis
      const response = await getImoveis({
        disponivel: 'true'
      });
      
      const pesquisa = pesquisaImovelConstrutor.toLowerCase();
      
      // Filtrar por todos os campos da tabela de imóveis
      const filtrados = response.data.filter(imovel => {
        // Campos da tabela: código, tipo, bairro, cidade
        const codigo = imovel.codigo?.toLowerCase() || '';
        const tipo = imovel.tipo?.toLowerCase() || '';
        const bairro = imovel.bairro?.toLowerCase() || '';
        const cidade = imovel.cidade?.toLowerCase() || '';
        const estado = imovel.estado?.toLowerCase() || '';
        const endereco = imovel.endereco?.toLowerCase() || '';
        
        // Verificar se a pesquisa corresponde a algum campo
        return codigo.includes(pesquisa) ||
               tipo.includes(pesquisa) ||
               bairro.includes(pesquisa) ||
               cidade.includes(pesquisa) ||
               estado.includes(pesquisa) ||
               endereco.includes(pesquisa) ||
               `${bairro}, ${cidade}`.includes(pesquisa) ||
               `${cidade}, ${estado}`.includes(pesquisa);
      });
      
      setImoveisDisponiveisConstrutor(filtrados);
    } catch (error) {
      console.error('Erro ao buscar imóveis:', error);
      setImoveisDisponiveisConstrutor([]);
    } finally {
      setLoadingImoveisConstrutor(false);
    }
  };
  
  // Adicionar imóvel ao construtor
  const handleAdicionarImovelConstrutor = async (imovelId) => {
    const imovel = imoveisDisponiveisConstrutor.find(i => i.id === imovelId) || imoveisList.find(i => i.id === imovelId);
    if (!imovel) return;
    
    if (!construtorFormData.imoveis.find(i => i.id === imovel.id)) {
      setConstrutorFormData(prev => ({
        ...prev,
        imoveis: [...prev.imoveis, imovel]
      }));
    }
    setPesquisaImovelConstrutor('');
    setImoveisDisponiveisConstrutor([]);
  };
  
  // Remover imóvel do construtor
  const handleRemoverImovelConstrutor = (imovelId) => {
    setConstrutorFormData(prev => ({
      ...prev,
      imoveis: prev.imoveis.filter(i => i.id !== imovelId)
    }));
  };
  
  // useEffect para buscar imóveis quando pesquisa mudar (construtor)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (pesquisaImovelConstrutor && construtorModalTab === 'imoveis') {
        buscarImoveisParaConstrutor();
      }
    }, 500);
    
    return () => clearTimeout(timer);
  }, [pesquisaImovelConstrutor, construtorModalTab]);
  
  const handleEditConstrutor = async (construtor) => {
    try {
      // Buscar dados completos do construtor (incluindo encarregados e imóveis)
      const response = await getConstrutor(construtor.id);
      const construtorCompleto = response.data;
      
      setEditingConstrutor(construtorCompleto);
      
      // Determinar tipo de documento baseado no tipo_documento_id ou no tamanho do CPF/CNPJ
      let tipoDocumento = 'CPF';
      if (construtorCompleto.tipo_documento_id) {
        const tipoDoc = tiposDocumento.find(td => td.id === construtorCompleto.tipo_documento_id);
        if (tipoDoc) {
          tipoDocumento = tipoDoc.nome;
        }
      } else if (construtorCompleto.cpf_cnpj) {
        tipoDocumento = construtorCompleto.cpf_cnpj.length === 14 ? 'CPF' : construtorCompleto.cpf_cnpj.length === 18 ? 'CNPJ' : 'CPF';
      }
      
      // Preencher formulário com dados do construtor
      const obrasConstrutor = construtorCompleto.obras || {};
      setConstrutorFormData({
        nome: construtorCompleto.nome || '',
        tipoDocumento: tipoDocumento,
        cpf_cnpj: construtorCompleto.cpf_cnpj || '',
        tel_celular_principal: construtorCompleto.tel_celular_principal || construtorCompleto.celular_pessoal || '',
        tel_celular_comercial: construtorCompleto.tel_celular_comercial || construtorCompleto.celular_coorporativo || '',
        tel_comercial: construtorCompleto.tel_comercial || construtorCompleto.telefone_residencial || '',
        email_corporativo: construtorCompleto.email_corporativo || construtorCompleto.email_principal || '',
        email_secundario: construtorCompleto.email_secundario || '',
        imoveis: Array.isArray(construtorCompleto.imoveis) ? construtorCompleto.imoveis : [],
        obras: {
          empreiteiro: Array.isArray(obrasConstrutor.empreiteiro) ? obrasConstrutor.empreiteiro : [],
          mestreObra: Array.isArray(obrasConstrutor.mestreObra) ? obrasConstrutor.mestreObra : [],
          pedreiro: Array.isArray(obrasConstrutor.pedreiro) ? obrasConstrutor.pedreiro : [],
          vigia: Array.isArray(obrasConstrutor.vigia) ? obrasConstrutor.vigia : []
        }
      });
      // Carregar lista de imóveis para seleção
      loadImoveisList();
      setShowConstrutorModal(true);
    } catch (error) {
      console.error('Erro ao carregar construtor:', error);
      alert('Erro ao carregar dados do construtor');
    }
  };

  const handleSubmitConstrutor = async (e) => {
    e.preventDefault();
    if (savingConstrutor) return; // Prevenir cliques duplos
    setSavingConstrutor(true);
    try {
      // Encontrar tipo de documento
      const tipoDocCPF = tiposDocumento.find(td => td.nome === 'CPF');
      const tipoDocCNPJ = tiposDocumento.find(td => td.nome === 'CNPJ');
      const tipoDocId = construtorFormData.tipoDocumento === 'CPF' 
        ? (tipoDocCPF?.id || null) 
        : (tipoDocCNPJ?.id || null);

      const data = {
        nome: construtorFormData.nome,
        tipo_documento_id: tipoDocId,
        cpf_cnpj: construtorFormData.cpf_cnpj || null,
        tel_comercial: construtorFormData.tel_comercial || null,
        tel_celular_principal: construtorFormData.tel_celular_principal || null,
        tel_celular_secundario: construtorFormData.tel_celular_comercial || null,
        email_corporativo: construtorFormData.email_corporativo || null,
        email_secundario: construtorFormData.email_secundario || null,
        imoveis: Array.isArray(construtorFormData.imoveis) ? construtorFormData.imoveis.map(i => i.id || i) : [],
        obras: construtorFormData.obras || {
          empreiteiro: [],
          mestreObra: [],
          pedreiro: [],
          vigia: []
        }
      };
      
      if (editingConstrutor) {
        await updateConstrutor(editingConstrutor.id, data);
      } else {
        await createConstrutor(data);
      }
      setShowConstrutorModal(false);
      setEditingConstrutor(null);
      resetConstrutorForm();
      loadConstrutores();
    } catch (error) {
      console.error('Erro ao salvar construtor:', error);
      const errorMessage = error.response?.data?.error || 'Erro ao salvar construtor';
      alert(errorMessage);
    } finally {
      setSavingConstrutor(false);
    }
  };
  
  const resetConstrutorForm = () => {
    setEditingConstrutor(null);
    setConstrutorFormData({
      nome: '',
      tipoDocumento: 'CPF',
      cpf_cnpj: '',
      tel_celular_principal: '',
      tel_celular_comercial: '',
      tel_comercial: '',
      email_corporativo: '',
      email_secundario: '',
      imoveis: [],
      obras: {
        empreiteiro: [],
        mestreObra: [],
        pedreiro: [],
        vigia: []
      }
    });
    setConstrutorModalTab('construtor');
    setPesquisaImovelConstrutor('');
    setImoveisDisponiveisConstrutor([]);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'novo':
        return 'status-novo';
      case 'em_andamento':
        return 'status-em_andamento';
      case 'convertido':
        return 'status-convertido';
      default:
        return '';
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0
    }).format(value);
  };

  return (
    <>
      <LoadingOverlay isLoading={loading} message="Carregando dashboard..." />
      <div className="dashboard">
      <div className="dashboard-header">
        <div className="dashboard-tabs">
          <button 
            className={activeTab === 'overview' ? 'active' : ''}
            onClick={() => setActiveTab('overview')}
          >
            Visão Geral
          </button>
          <button 
            className={activeTab === 'imoveis' ? 'active' : ''}
            onClick={() => setActiveTab('imoveis')}
          >
            Imóveis
          </button>
          <button 
            className={activeTab === 'clientes' ? 'active' : ''}
            onClick={() => setActiveTab('clientes')}
          >
            Clientes
          </button>
          <button 
            className={activeTab === 'construtores' ? 'active' : ''}
            onClick={() => setActiveTab('construtores')}
          >
            Construtores
          </button>
          <button 
            className={activeTab === 'agendamentos' ? 'active' : ''}
            onClick={() => setActiveTab('agendamentos')}
          >
            Agendamentos
          </button>
        </div>
      </div>

      {activeTab === 'overview' && stats && (
        <OverviewTab 
          stats={stats} 
          recent={recent} 
          formatCurrency={formatCurrency}
          onEditDestaques={() => {
            setActiveTab('imoveis');
          }}
        />
      )}

      {showImovelModal && (
        <div className="form-modal" onClick={(e) => {
          if (e.target.className === 'form-modal') {
            const temUnidadesSalvas = !editingImovel && unidadesSalvasIds.length > 0;
            const temProgresso = !editingImovel && totalImoveisCadastro > 1 && (unidadesPendentes.length > 0 || unidadeAtual > 1);
            if (temUnidadesSalvas) {
              if (!window.confirm(`Já existem ${unidadesSalvasIds.length} unidade(s) salva(s). Ao cancelar, elas permanecerão. Deseja fechar?`)) return;
            } else if (temProgresso && !window.confirm('Tem certeza que deseja cancelar? Nenhum imóvel será salvo.')) {
              return;
            }
            setShowImovelModal(false);
            resetImovelForm();
          }
        }}>
          <div className="form-content" style={{ maxWidth: '900px', maxHeight: '90vh', overflowY: 'auto' }} onClick={(e) => e.stopPropagation()}>
            <div className="form-header">
              <h2>
                {editingImovel 
                  ? 'Editar Imóvel' 
                  : totalImoveisCadastro > 1 
                    ? `Adicionar Imóvel - Unidade ${unidadeAtual} de ${totalImoveisCadastro}`
                    : 'Adicionar Imóvel'
                }
              </h2>
              <button className="btn-close" onClick={() => {
                const temUnidadesSalvas = !editingImovel && unidadesSalvasIds.length > 0;
                const temProgresso = !editingImovel && totalImoveisCadastro > 1 && (unidadesPendentes.length > 0 || unidadeAtual > 1);
                if (temUnidadesSalvas) {
                  if (!window.confirm(`Já existem ${unidadesSalvasIds.length} unidade(s) salva(s). Ao cancelar, elas permanecerão. Deseja fechar?`)) return;
                } else if (temProgresso && !window.confirm('Tem certeza que deseja cancelar? Nenhum imóvel será salvo.')) {
                  return;
                }
                setShowImovelModal(false);
                resetImovelForm();
              }}>×</button>
            </div>
            <form onSubmit={handleSubmitImovel} className="imovel-form">
              {/* Informações sobre múltiplos imóveis */}
              {!editingImovel && totalImoveisCadastro > 1 && unidadeAtual > 1 && (
                <div className="info-box" style={{ 
                  background: '#e3f2fd', 
                  padding: '1rem', 
                  borderRadius: '5px', 
                  marginBottom: '1rem',
                  border: '1px solid #2196f3'
                }}>
                  <strong>Cadastrando Unidade {unidadeAtual} de {totalImoveisCadastro}</strong>
                  <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem', color: '#666' }}>
                    Os dados de Tipo, Cidade, Bairro, Estado, Rua, Construtor, Tags e Fotos foram copiados da primeira unidade.
                    Preencha apenas os dados específicos desta unidade (Código, Preço, Número, Características, etc.).
                  </p>
                </div>
              )}

              {/* Principais */}
              <h3>Principais</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>Código *</label>
                  <input
                    type="text"
                    value={imovelFormData.codigo}
                    onChange={(e) => {
                      const novoCodigo = e.target.value;
                      setImovelFormData({ ...imovelFormData, codigo: novoCodigo });
                      
                      // Verificar se o código já existe (apenas ao criar novo imóvel)
                      if (!editingImovel && novoCodigo.trim() !== '') {
                        const imoveisComMesmoCodigo = imoveis.filter(i => i.codigo === novoCodigo);
                        if (imoveisComMesmoCodigo.length > 0) {
                          setCodigoDuplicadoAviso({
                            quantidade: imoveisComMesmoCodigo.length,
                            codigo: novoCodigo
                          });
                        } else {
                          setCodigoDuplicadoAviso(null);
                        }
                      } else {
                        setCodigoDuplicadoAviso(null);
                      }
                    }}
                    onBlur={() => {
                      // Limpar aviso ao sair do campo se não houver código
                      if (!imovelFormData.codigo || imovelFormData.codigo.trim() === '') {
                        setCodigoDuplicadoAviso(null);
                      }
                    }}
                    required
                    style={{
                      borderColor: codigoDuplicadoAviso ? '#ff9800' : undefined,
                      borderWidth: codigoDuplicadoAviso ? '2px' : undefined
                    }}
                  />
                  {codigoDuplicadoAviso && (
                    <div style={{ 
                      marginTop: '0.5rem', 
                      padding: '0.5rem', 
                      background: '#fff3cd', 
                      border: '1px solid #ffc107', 
                      borderRadius: '4px',
                      fontSize: '0.85rem',
                      color: '#856404'
                    }}>
                      ⚠️ Já existem {codigoDuplicadoAviso.quantidade} imóvel(is) cadastrado(s) com o código "{codigoDuplicadoAviso.codigo}". 
                      Você pode continuar o cadastro usando este código.
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label>Tipo *</label>
                  <select
                    value={imovelFormData.tipo}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, tipo: e.target.value })}
                    required
                    disabled={!editingImovel && totalImoveisCadastro > 1 && unidadeAtual > 1}
                  >
                    <option value="">Selecione o tipo</option>
                    <option value="Apartamento">Apartamento</option>
                    <option value="Casa">Casa</option>
                    <option value="Casa Geminada">Casa Geminada</option>
                    <option value="Chácara">Chácara</option>
                    <option value="Cobertura">Cobertura</option>
                    <option value="Lote">Lote</option>
                    <option value="Sitio">Sitio</option>
                  </select>
                </div>
                {!editingImovel && unidadeAtual === 1 && (
                  <div className="form-group">
                    <label>Quantos imóveis ao todo? *</label>
                    <select
                      value={imovelFormData.totalImoveis || '1'}
                      onChange={(e) => {
                        const total = parseInt(e.target.value);
                        setImovelFormData({ ...imovelFormData, totalImoveis: total });
                        setTotalImoveisCadastro(total);
                      }}
                      required
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </select>
                  </div>
                )}
                <div className="form-group">
                  <label>Preço</label>
                  <input
                    type="text"
                    value={imovelFormData.preco}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, preco: maskCurrency(e.target.value) })}
                    placeholder="R$ 0,00"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Tags</label>
                {tags.length > 0 ? (
                  <>
                    <select
                      multiple
                      value={imovelFormData.tags}
                      onChange={(e) => {
                        const selectedTags = Array.from(e.target.selectedOptions, option => option.value);
                        setImovelFormData({ ...imovelFormData, tags: selectedTags });
                      }}
                      style={{ minHeight: '100px' }}
                      disabled={!editingImovel && totalImoveisCadastro > 1 && unidadeAtual > 1}
                    >
                      {tags.map(tag => (
                        <option key={tag} value={tag}>{tag}</option>
                      ))}
                    </select>
                    <small style={{ color: '#666', fontSize: '0.85rem' }}>Mantenha Ctrl/Cmd pressionado para selecionar múltiplas tags</small>
                  </>
                ) : (
                  <p style={{ color: '#666', fontSize: '0.85rem', fontStyle: 'italic' }}>Nenhuma tag cadastrada ainda</p>
                )}
              </div>

              {/* Área */}
              <h3>Área</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>Área Construída (m²)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={imovelFormData.areaConstruida}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, areaConstruida: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Área Externa (m²)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={imovelFormData.areaExterna}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, areaExterna: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Área do Lote (m²)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={imovelFormData.areaLote}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, areaLote: e.target.value })}
                  />
                </div>
              </div>

              {/* Unidade */}
              {!editingImovel && (imovelFormData.totalImoveis > 1 || totalImoveisCadastro > 1) && (
                <>
                  <h3>Unidade</h3>
                  <hr />
                  <div className="form-row">
                    <div className="form-group">
                      <label>Quantos estão disponíveis?</label>
                      <select
                        value={imovelFormData.unidadesDisponiveis}
                        onChange={(e) => setImovelFormData({ ...imovelFormData, unidadesDisponiveis: e.target.value })}
                      >
                        <option value="">Selecione...</option>
                        {Array.from({ length: (imovelFormData.totalImoveis || totalImoveisCadastro || 1) }, (_, i) => i + 1).map(num => (
                          <option key={num} value={num}>{num}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Quantos estão reservados?</label>
                      <select
                        value={imovelFormData.unidadesReservadas}
                        onChange={(e) => setImovelFormData({ ...imovelFormData, unidadesReservadas: e.target.value })}
                      >
                        <option value="">Selecione...</option>
                        {Array.from({ length: (imovelFormData.totalImoveis || totalImoveisCadastro || 1) - (parseInt(imovelFormData.unidadesDisponiveis) || 0) }, (_, i) => i + 1).map(num => (
                          <option key={num} value={num}>{num}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Quantos foram vendidos?</label>
                      <select
                        value={imovelFormData.unidadesVendidas}
                        onChange={(e) => setImovelFormData({ ...imovelFormData, unidadesVendidas: e.target.value })}
                      >
                        <option value="">Selecione...</option>
                        {Array.from({ length: (imovelFormData.totalImoveis || totalImoveisCadastro || 1) - (parseInt(imovelFormData.unidadesDisponiveis) || 0) - (parseInt(imovelFormData.unidadesReservadas) || 0) }, (_, i) => i + 1).map(num => (
                          <option key={num} value={num}>{num}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {/* Informações */}
              <h3>Informações</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>Quartos</label>
                  <select
                    value={imovelFormData.quartos}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, quartos: e.target.value })}
                  >
                    <option value="">Selecione...</option>
                    {Array.from({ length: 10 }, (_, i) => i + 1).map(num => (
                      <option key={num} value={num}>{num}</option>
                    ))}
                    <option value="11">Mais de 10</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Banheiros</label>
                  <select
                    value={imovelFormData.banheiros}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, banheiros: e.target.value })}
                  >
                    <option value="">Selecione...</option>
                    {Array.from({ length: 10 }, (_, i) => i + 1).map(num => (
                      <option key={num} value={num}>{num}</option>
                    ))}
                    <option value="11">Mais de 10</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Suítes</label>
                  <select
                    value={imovelFormData.suites}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, suites: e.target.value })}
                  >
                    <option value="">Selecione...</option>
                    {Array.from({ length: 10 }, (_, i) => i + 1).map(num => (
                      <option key={num} value={num}>{num}</option>
                    ))}
                    <option value="11">Mais de 10</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Lavabos</label>
                  <select
                    value={imovelFormData.lavabos}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, lavabos: e.target.value })}
                  >
                    <option value="">Selecione...</option>
                    {Array.from({ length: 5 }, (_, i) => i + 1).map(num => (
                      <option key={num} value={num}>{num}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Garagem</label>
                  <select
                    value={imovelFormData.garagem}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, garagem: e.target.value })}
                  >
                    <option value="">Selecione...</option>
                    {Array.from({ length: 10 }, (_, i) => i + 1).map(num => (
                      <option key={num} value={num}>{num}</option>
                    ))}
                    <option value="11">Mais de 10</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Descrição</label>
                <textarea
                  value={imovelFormData.descricao}
                  onChange={(e) => setImovelFormData({ ...imovelFormData, descricao: e.target.value })}
                  rows="4"
                  placeholder="Descrição do imóvel que será exibida na página de detalhes"
                />
              </div>

              {/* Anotações */}
              <h3>Anotações</h3>
              <hr />
              <div className="form-group">
                <label>Detalhes</label>
                <textarea
                  value={imovelFormData.detalhes}
                  onChange={(e) => setImovelFormData({ ...imovelFormData, detalhes: e.target.value })}
                  rows="4"
                />
              </div>
              <div className="form-group">
                <label>Observações</label>
                <textarea
                  value={imovelFormData.observacoes}
                  onChange={(e) => setImovelFormData({ ...imovelFormData, observacoes: e.target.value })}
                  rows="4"
                />
              </div>

              {/* Obra */}
              <h3>Obra</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>Construtor</label>
                  <select
                    value={imovelFormData.construtorId}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, construtorId: e.target.value })}
                  >
                    <option value="">Selecione...</option>
                    {construtoresList.map(construtor => (
                      <option key={construtor.id} value={construtor.id}>
                        {construtor.nome}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Situação *</label>
                  <select
                    value={imovelFormData.situacao_id}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, situacao_id: e.target.value })}
                    required
                  >
                    <option value="">Selecione...</option>
                    {situacoes.map(situacao => (
                      <option key={situacao.id} value={situacao.id}>
                        {situacao.nome}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Status da Construção *</label>
                  <select
                    value={imovelFormData.status_construcao_id}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, status_construcao_id: e.target.value })}
                    required
                  >
                    <option value="">Selecione...</option>
                    {statusConstrucaoList.map(status => (
                      <option key={status.id} value={status.id}>
                        {status.nome}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Endereço */}
              <h3>Endereço</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>CEP</label>
                  <input
                    type="text"
                    value={imovelFormData.cep}
                    onChange={handleImovelCEPChange}
                    placeholder="00000-000"
                    maxLength={9}
                    disabled={!editingImovel && totalImoveisCadastro > 1 && unidadeAtual > 1}
                  />
                </div>
                <div className="form-group">
                  <label>Rua</label>
                  <input
                    type="text"
                    value={imovelFormData.rua}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, rua: e.target.value })}
                    placeholder="Nome da rua"
                    disabled={!editingImovel && totalImoveisCadastro > 1 && unidadeAtual > 1}
                  />
                </div>
                <div className="form-group">
                  <label>Número</label>
                  <input
                    type="text"
                    value={imovelFormData.numero}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, numero: e.target.value })}
                    placeholder="Número"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Bairro</label>
                  <input
                    type="text"
                    value={imovelFormData.bairro}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, bairro: e.target.value })}
                    placeholder="Nome do bairro"
                    disabled={!editingImovel && totalImoveisCadastro > 1 && unidadeAtual > 1}
                  />
                </div>
                <div className="form-group">
                  <label>Cidade</label>
                  <input
                    type="text"
                    value={imovelFormData.cidade}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, cidade: e.target.value })}
                    placeholder="Nome da cidade"
                    disabled={!editingImovel && totalImoveisCadastro > 1 && unidadeAtual > 1}
                  />
                </div>
                <div className="form-group">
                  <label>Estado</label>
                  <select
                    value={imovelFormData.estado}
                    onChange={(e) => setImovelFormData({ ...imovelFormData, estado: e.target.value })}
                    disabled={!editingImovel && totalImoveisCadastro > 1 && unidadeAtual > 1}
                  >
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                  </select>
                </div>
              </div>

              {/* Fotos */}
              <h3>Fotos</h3>
              <hr />
              <div className="form-group">
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleImovelPhotoUpload}
                  disabled={uploadingPhotos || (!editingImovel && totalImoveisCadastro > 1 && unidadeAtual > 1)}
                />
                {uploadingPhotos && <p>Fazendo upload...</p>}
              </div>
              {imovelFormData.fotos.length > 0 && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '1rem', marginTop: '1rem' }}>
                  {imovelFormData.fotos.map((foto, index) => {
                    // Verificar se a foto é válida antes de renderizar
                    if (!foto) {
                      return null;
                    }
                    return (
                      <div 
                        key={index} 
                        draggable
                        onDragStart={(e) => handleDragStart(e, index)}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, index)}
                        style={{ 
                          position: 'relative',
                          cursor: 'move',
                          opacity: 1
                        }}
                      >
                        <img 
                          src={foto} 
                          alt={`Foto ${index + 1}`} 
                          style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '4px', pointerEvents: 'none' }}
                          onError={(e) => {
                            // Se a imagem falhar ao carregar, remover do array
                            console.warn(`Foto ${index + 1} falhou ao carregar, removendo...`);
                            removeImovelPhoto(index);
                          }}
                        />
                        <div style={{ position: 'absolute', top: '5px', left: '5px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          {index > 0 && (
                            <button
                              type="button"
                              onClick={(e) => { e.stopPropagation(); moveImovelPhoto(index, 'up'); }}
                              style={{
                                background: '#1b3540',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                width: '24px',
                                height: '24px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              title="Mover para cima"
                            >
                              ↑
                            </button>
                          )}
                          {index < imovelFormData.fotos.length - 1 && (
                            <button
                              type="button"
                              onClick={(e) => { e.stopPropagation(); moveImovelPhoto(index, 'down'); }}
                              style={{
                                background: '#1b3540',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                width: '24px',
                                height: '24px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              title="Mover para baixo"
                            >
                              ↓
                            </button>
                          )}
                        </div>
                        <button
                          type="button"
                          onClick={(e) => { e.stopPropagation(); removeImovelPhoto(index); }}
                          style={{
                            position: 'absolute',
                            top: '5px',
                            right: '5px',
                            background: 'red',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            cursor: 'pointer',
                            zIndex: 10
                          }}
                          title="Remover foto"
                        >
                          ×
                        </button>
                        <div style={{ position: 'absolute', bottom: '5px', left: '50%', transform: 'translateX(-50%)', background: 'rgba(0,0,0,0.7)', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', pointerEvents: 'none' }}>
                          {index + 1}/{imovelFormData.fotos.length}
                        </div>
                        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'rgba(27, 53, 64, 0.8)', color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', pointerEvents: 'none', display: 'none' }} className="drag-hint">
                          Arraste para ordenar
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {imovelFormData.fotos.length > 0 && (
                <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#666', fontStyle: 'italic' }}>
                  💡 Dica: Arraste as fotos para reordená-las ou use os botões ↑ ↓
                </p>
              )}

              <div className="form-actions" style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                {editingImovel && (() => {
                  const outrasUnidades = imoveis.filter(i => i.codigo === editingImovel.codigo && i.id !== editingImovel.id);
                  const temOutrasUnidades = outrasUnidades.length > 0;
                  
                  return temOutrasUnidades ? (
                    <button 
                      type="button" 
                      className="btn-delete" 
                      onClick={() => handleDeleteUnidade(editingImovel.id)}
                      disabled={savingImovel}
                      style={{ 
                        background: '#dc3545', 
                        color: 'white',
                        marginRight: 'auto',
                        padding: '0.5rem 1rem',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: savingImovel ? 'not-allowed' : 'pointer',
                        opacity: savingImovel ? 0.6 : 1
                      }}
                    >
                      Remover
                    </button>
                  ) : null;
                })()}
                <button type="button" className="btn-cancel" onClick={() => {
                  const temUnidadesSalvas = !editingImovel && unidadesSalvasIds.length > 0;
                  const temProgresso = !editingImovel && totalImoveisCadastro > 1 && (unidadesPendentes.length > 0 || unidadeAtual > 1);
                  if (temUnidadesSalvas) {
                    if (!window.confirm(`Já existem ${unidadesSalvasIds.length} unidade(s) salva(s). Ao cancelar, elas permanecerão. Deseja fechar?`)) return;
                  } else if (temProgresso && !window.confirm('Tem certeza que deseja cancelar? Nenhum imóvel será salvo.')) {
                    return;
                  }
                  setShowImovelModal(false);
                  resetImovelForm();
                }} disabled={savingImovel}>
                  Cancelar
                </button>
                {!editingImovel && totalImoveisCadastro > 1 && (
                  <>
                    <button
                      type="button"
                      className="btn-save"
                      onClick={handleAvançar}
                      disabled={savingImovel || unidadeAtual >= totalImoveisCadastro}
                    >
                      Avançar
                    </button>
                    <button type="submit" className="btn-save" disabled={savingImovel}>
                      {savingImovel ? 'Salvando...' : 'Concluir'}
                    </button>
                  </>
                )}
                {(!editingImovel && totalImoveisCadastro <= 1) && (
                  <button type="submit" className="btn-save" disabled={savingImovel}>
                    {savingImovel ? 'Salvando...' : 'Salvar'}
                  </button>
                )}
                {editingImovel && (
                  <button type="submit" className="btn-save" disabled={savingImovel}>
                    {savingImovel ? 'Salvando...' : 'Salvar'}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      )}

      {showClienteModal && (
        <div className="form-modal" onClick={(e) => e.target.className === 'form-modal' && (setShowClienteModal(false), resetClienteForm())}>
          <div className="form-content" style={{ maxWidth: '900px', maxHeight: '90vh', overflowY: 'auto' }} onClick={(e) => e.stopPropagation()}>
            <div className="form-header">
              <h2>{editingCliente ? 'Editar Cliente' : 'Adicionar Cliente'}</h2>
              <button className="btn-close" onClick={() => { setShowClienteModal(false); resetClienteForm(); }}>×</button>
            </div>
            
            {/* Abas */}
            <div style={{ display: 'flex', borderBottom: '2px solid #ddd', marginBottom: '1.5rem' }}>
              <button
                type="button"
                onClick={() => setClienteModalTab('cliente')}
                style={{
                  padding: '0.75rem 1.5rem',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  borderBottom: clienteModalTab === 'cliente' ? '2px solid #1b3540' : 'none',
                  color: clienteModalTab === 'cliente' ? '#1b3540' : '#666',
                  fontWeight: clienteModalTab === 'cliente' ? 'bold' : 'normal'
                }}
              >
                Cliente
              </button>
              <button
                type="button"
                onClick={() => {
                  setClienteModalTab('imoveis');
                  if (editingCliente?.id) {
                    loadImoveisRelacionadosCliente(editingCliente.id);
                  }
                }}
                style={{
                  padding: '0.75rem 1.5rem',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  borderBottom: clienteModalTab === 'imoveis' ? '2px solid #1b3540' : 'none',
                  color: clienteModalTab === 'imoveis' ? '#1b3540' : '#666',
                  fontWeight: clienteModalTab === 'imoveis' ? 'bold' : 'normal'
                }}
              >
                Imóveis Desejados
              </button>
            </div>
            
            {clienteModalTab === 'cliente' ? (
            <form onSubmit={handleSubmitCliente} className="imovel-form">
              {/* Dados Pessoais */}
              <h3>Dados Pessoais</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>Nome *</label>
                  <input
                    type="text"
                    value={clienteFormData.nome}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, nome: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Tipo de Documento</label>
                  <select
                    value={clienteFormData.tipoDocumento}
                    onChange={(e) => {
                      setClienteFormData({ ...clienteFormData, tipoDocumento: e.target.value, cpfCnpj: '' });
                    }}
                  >
                    <option value="CPF">CPF</option>
                    <option value="CNPJ">CNPJ</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>{clienteFormData.tipoDocumento === 'CPF' ? 'CPF' : 'CNPJ'}</label>
                  <input
                    type="text"
                    value={clienteFormData.cpfCnpj}
                    onChange={(e) => setClienteFormData({ 
                      ...clienteFormData, 
                      cpfCnpj: clienteFormData.tipoDocumento === 'CPF' ? maskCPF(e.target.value) : maskCNPJ(e.target.value)
                    })}
                    maxLength={clienteFormData.tipoDocumento === 'CPF' ? 14 : 18}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Acesso Mídia</label>
                  <select
                    value={clienteFormData.acessoMidia}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, acessoMidia: e.target.value })}
                  >
                    <option value="">Selecione...</option>
                    {opcoesAcessoMidia.map(opcao => (
                      <option key={opcao} value={opcao}>{opcao}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Data de Nascimento</label>
                  <input
                    type="date"
                    value={clienteFormData.dataNascimento}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, dataNascimento: e.target.value })}
                  />
                </div>
              </div>

              {/* Contato */}
              <h3>Contato</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>Celular Pessoal</label>
                  <input
                    type="text"
                    value={clienteFormData.celularPessoal}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, celularPessoal: maskPhone(e.target.value) })}
                    placeholder="(XX) XXXXX-XXXX"
                  />
                </div>
                <div className="form-group">
                  <label>Celular Comercial</label>
                  <input
                    type="text"
                    value={clienteFormData.celularComercial}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, celularComercial: maskPhone(e.target.value) })}
                    placeholder="(XX) XXXXX-XXXX"
                  />
                </div>
                <div className="form-group">
                  <label>Telefone Residencial</label>
                  <input
                    type="text"
                    value={clienteFormData.telefoneResidencial}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, telefoneResidencial: maskPhone(e.target.value) })}
                    placeholder="(XX) XXXX-XXXX"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>E-mail Principal</label>
                  <input
                    type="email"
                    value={clienteFormData.emailPrincipal}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, emailPrincipal: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>E-mail Secundário</label>
                  <input
                    type="email"
                    value={clienteFormData.emailSecundario}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, emailSecundario: e.target.value })}
                  />
                </div>
              </div>

              {/* Endereço */}
              <h3>Endereço</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>CEP</label>
                  <input
                    type="text"
                    value={clienteFormData.cep}
                    onChange={handleClienteCEPChange}
                    placeholder="00000-000"
                    maxLength={9}
                  />
                </div>
                <div className="form-group">
                  <label>Rua</label>
                  <input
                    type="text"
                    value={clienteFormData.rua}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, rua: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Bairro</label>
                  <input
                    type="text"
                    value={clienteFormData.bairro}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, bairro: e.target.value })}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Cidade</label>
                  <input
                    type="text"
                    value={clienteFormData.cidade}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, cidade: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Estado</label>
                  <input
                    type="text"
                    value={clienteFormData.estado}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, estado: e.target.value })}
                    maxLength={2}
                  />
                </div>
              </div>

              {/* Compra Conjunta */}
              <h3>Compra Conjunta</h3>
              <hr />
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={clienteFormData.compraConjunta}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, compraConjunta: e.target.checked })}
                  />
                  <span>Compra conjunta?</span>
                </label>
              </div>
              {clienteFormData.compraConjunta && (
                <>
                  <h4 style={{ marginTop: '1rem', marginBottom: '0.5rem' }}>Segundo Comprador</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Nome</label>
                      <input
                        type="text"
                        value={clienteFormData.segundoCompradorNome}
                        onChange={(e) => setClienteFormData({ ...clienteFormData, segundoCompradorNome: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <label>CPF</label>
                      <input
                        type="text"
                        value={clienteFormData.segundoCompradorCPF}
                        onChange={(e) => setClienteFormData({ ...clienteFormData, segundoCompradorCPF: maskCPF(e.target.value) })}
                        maxLength={14}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Celular Pessoal</label>
                      <input
                        type="text"
                        value={clienteFormData.segundoCompradorCelularPessoal}
                        onChange={(e) => setClienteFormData({ ...clienteFormData, segundoCompradorCelularPessoal: maskPhone(e.target.value) })}
                      />
                    </div>
                    <div className="form-group">
                      <label>Celular Comercial</label>
                      <input
                        type="text"
                        value={clienteFormData.segundoCompradorCelularComercial}
                        onChange={(e) => setClienteFormData({ ...clienteFormData, segundoCompradorCelularComercial: maskPhone(e.target.value) })}
                      />
                    </div>
                    <div className="form-group">
                      <label>Telefone Residencial</label>
                      <input
                        type="text"
                        value={clienteFormData.segundoCompradorTelefoneResidencial}
                        onChange={(e) => setClienteFormData({ ...clienteFormData, segundoCompradorTelefoneResidencial: maskPhone(e.target.value) })}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>E-mail Principal</label>
                      <input
                        type="email"
                        value={clienteFormData.segundoCompradorEmailPrincipal}
                        onChange={(e) => setClienteFormData({ ...clienteFormData, segundoCompradorEmailPrincipal: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <label>E-mail Secundário</label>
                      <input
                        type="email"
                        value={clienteFormData.segundoCompradorEmailSecundario}
                        onChange={(e) => setClienteFormData({ ...clienteFormData, segundoCompradorEmailSecundario: e.target.value })}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Detalhes do Cliente */}
              <h3>Detalhes do Cliente</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>Situação *</label>
                  <select
                    value={clienteFormData.situacao_id}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, situacao_id: e.target.value })}
                    required
                  >
                    <option value="">Selecione...</option>
                    {clientesSituacoes.map(situacao => (
                      <option key={situacao.id} value={situacao.id}>
                        {situacao.nome}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Renda</label>
                  <input
                    type="text"
                    value={clienteFormData.renda}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, renda: maskCurrency(e.target.value) })}
                    placeholder="R$ 0,00"
                  />
                </div>
                <div className="form-group">
                  <label>Saldo FGTS</label>
                  <input
                    type="text"
                    value={clienteFormData.saldoFGTS}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, saldoFGTS: maskCurrency(e.target.value) })}
                    placeholder="R$ 0,00"
                  />
                </div>
                <div className="form-group">
                  <label>Valor de Entrada</label>
                  <input
                    type="text"
                    value={clienteFormData.valorEntrada}
                    onChange={(e) => setClienteFormData({ ...clienteFormData, valorEntrada: maskCurrency(e.target.value) })}
                    placeholder="R$ 0,00"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Observações de Entrada</label>
                <textarea
                  value={clienteFormData.observacoesEntrada}
                  onChange={(e) => setClienteFormData({ ...clienteFormData, observacoesEntrada: e.target.value })}
                  rows="3"
                />
              </div>
              <div className="form-group">
                <label>Observações de Atendimento</label>
                <textarea
                  value={clienteFormData.observacoesAtendimento}
                  onChange={(e) => setClienteFormData({ ...clienteFormData, observacoesAtendimento: e.target.value })}
                  rows="3"
                />
              </div>

              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={() => { setShowClienteModal(false); resetClienteForm(); }} disabled={savingCliente}>
                  Cancelar
                </button>
                <button type="submit" className="btn-save" disabled={savingCliente}>
                  {savingCliente ? 'Salvando...' : (editingCliente ? 'Salvar Alterações' : 'Salvar Cliente')}
                </button>
                {!editingCliente && (
                  <button 
                    type="button" 
                    className="btn-save" 
                    style={{ marginLeft: '0.5rem', backgroundColor: '#667eea' }}
                    onClick={async (e) => {
                      e.preventDefault();
                      if (savingCliente) return;
                      setSavingCliente(true);
                      // Salvar o cliente primeiro
                      try {
                        const data = {
                          nome: clienteFormData.nome,
                          email: clienteFormData.emailPrincipal,
                          telefone: clienteFormData.celularPessoal,
                          tipo: 'comprador',
                          cpfCnpj: clienteFormData.cpfCnpj,
                          acessoMidia: clienteFormData.acessoMidia,
                          dataNascimento: clienteFormData.dataNascimento,
                          celularComercial: clienteFormData.celularComercial,
                          telefoneResidencial: clienteFormData.telefoneResidencial,
                          emailSecundario: clienteFormData.emailSecundario,
                          cep: clienteFormData.cep,
                          rua: clienteFormData.rua,
                          bairro: clienteFormData.bairro,
                          cidade: clienteFormData.cidade,
                          estado: clienteFormData.estado,
                          compraConjunta: clienteFormData.compraConjunta,
                          segundoCompradorNome: clienteFormData.segundoCompradorNome,
                          segundoCompradorCPF: clienteFormData.segundoCompradorCPF,
                          segundoCompradorCelularPessoal: clienteFormData.segundoCompradorCelularPessoal,
                          segundoCompradorCelularComercial: clienteFormData.segundoCompradorCelularComercial,
                          segundoCompradorTelefoneResidencial: clienteFormData.segundoCompradorTelefoneResidencial,
                          segundoCompradorEmailPrincipal: clienteFormData.segundoCompradorEmailPrincipal,
                          segundoCompradorEmailSecundario: clienteFormData.segundoCompradorEmailSecundario,
                          situacao: clienteFormData.situacao,
                          renda: currencyToNumber(clienteFormData.renda),
                          saldoFGTS: currencyToNumber(clienteFormData.saldoFGTS),
                          valorEntrada: currencyToNumber(clienteFormData.valorEntrada),
                          observacoesEntrada: clienteFormData.observacoesEntrada,
                          observacoesAtendimento: clienteFormData.observacoesAtendimento
                        };
                        const response = await createCliente(data);
                        const clienteSalvo = response.data;
                        setEditingCliente(clienteSalvo);
                        setImoveisRelacionadosCliente([]);
                        setClienteModalTab('imoveis');
                        loadClientes();
                        alert('Cliente salvo com sucesso! Agora você pode adicionar imóveis desejados.');
                      } catch (error) {
                        console.error('Erro ao salvar cliente:', error);
                        const errorMessage = error.response?.data?.error || 'Erro ao salvar cliente';
                        alert(errorMessage);
                      } finally {
                        setSavingCliente(false);
                      }
                    }}
                    disabled={savingCliente}
                  >
                    {savingCliente ? 'Salvando...' : 'Salvar e Adicionar Imóveis'}
                  </button>
                )}
              </div>
            </form>
            ) : (
              <div className="imovel-form">
                <h3>Imóveis Desejados</h3>
                <hr />
                
                {!editingCliente?.id ? (
                  <p style={{ color: '#666', fontStyle: 'italic', marginTop: '1rem' }}>
                    Preencha os dados do cliente e clique em "Salvar e Adicionar Imóveis" para adicionar imóveis desejados.
                  </p>
                ) : (
                  <>
                    {/* Busca de imóveis */}
                    <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                      <label>Buscar Imóvel</label>
                      <input
                        type="text"
                        value={pesquisaImovelCliente}
                        onChange={(e) => setPesquisaImovelCliente(e.target.value)}
                        placeholder="Digite código, tipo, bairro, cidade ou endereço..."
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          border: '1px solid #ddd',
                          borderRadius: '5px',
                          fontSize: '0.9rem'
                        }}
                      />
                    </div>
                    
                    {/* Lista de imóveis encontrados */}
                    {loadingImoveisCliente && (
                      <p style={{ color: '#666', fontStyle: 'italic' }}>Buscando imóveis...</p>
                    )}
                    
                    {!loadingImoveisCliente && pesquisaImovelCliente && imoveisDisponiveis.length > 0 && (
                      <div style={{ marginBottom: '2rem' }}>
                        <h4 style={{ marginBottom: '1rem' }}>Imóveis Encontrados</h4>
                        <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '5px' }}>
                          {imoveisDisponiveis.map(imovel => (
                            <div
                              key={imovel.id}
                              style={{
                                padding: '1rem',
                                borderBottom: '1px solid #eee',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}
                            >
                              <div>
                                <strong>Código: {imovel.codigo}</strong> - {imovel.tipo}
                                <br />
                                <small style={{ color: '#666' }}>
                                  {imovel.bairro}, {imovel.cidade} - {imovel.endereco}
                                </small>
                              </div>
                              <button
                                type="button"
                                onClick={() => handleAdicionarImovelCliente(imovel.id)}
                                className="btn-save"
                                style={{ padding: '0.5rem 1rem', fontSize: '0.85rem' }}
                              >
                                Adicionar
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {!loadingImoveisCliente && pesquisaImovelCliente && imoveisDisponiveis.length === 0 && (
                      <p style={{ color: '#666', fontStyle: 'italic', marginBottom: '2rem' }}>
                        Nenhum imóvel encontrado.
                      </p>
                    )}
                    
                    {/* Lista de imóveis relacionados */}
                    <div>
                      <h4 style={{ marginBottom: '1rem' }}>Imóveis Relacionados</h4>
                      {loadingImoveisCliente && imoveisRelacionadosCliente.length === 0 ? (
                        <p style={{ color: '#666', fontStyle: 'italic' }}>Carregando...</p>
                      ) : imoveisRelacionadosCliente.length === 0 ? (
                        <p style={{ color: '#666', fontStyle: 'italic' }}>Nenhum imóvel relacionado ainda.</p>
                      ) : (
                        <div style={{ border: '1px solid #ddd', borderRadius: '5px' }}>
                          {imoveisRelacionadosCliente.map((relacao) => (
                            <div
                              key={relacao.id}
                              style={{
                                padding: '1rem',
                                borderBottom: '1px solid #eee',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}
                            >
                              <div>
                                <strong>Código: {relacao.codigo}</strong> - {relacao.tipo}
                                <br />
                                <small style={{ color: '#666' }}>
                                  {relacao.bairro}, {relacao.cidade} - {relacao.endereco}
                                </small>
                                {relacao.tipoInteresse && (
                                  <>
                                    <br />
                                    <small style={{ color: '#1b3540' }}>
                                      Tipo: {relacao.tipoInteresse}
                                    </small>
                                  </>
                                )}
                              </div>
                              <button
                                type="button"
                                onClick={() => handleRemoverImovelCliente(relacao.id)}
                                className="btn-action btn-delete"
                                title="Remover"
                              >
                                <FaTrash />
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    
                    <div className="form-actions" style={{ marginTop: '2rem' }}>
                      <button type="button" className="btn-cancel" onClick={() => { setShowClienteModal(false); resetClienteForm(); }}>
                        Fechar
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {showConstrutorModal && (
        <div className="form-modal" onClick={(e) => e.target.className === 'form-modal' && (setShowConstrutorModal(false), resetConstrutorForm())}>
          <div className="form-content" style={{ maxWidth: '900px', maxHeight: '90vh', overflowY: 'auto' }} onClick={(e) => e.stopPropagation()}>
            <div className="form-header">
              <h2>{editingConstrutor ? 'Editar Construtor' : 'Adicionar Construtor'}</h2>
              <button className="btn-close" onClick={() => { setShowConstrutorModal(false); resetConstrutorForm(); }}>×</button>
            </div>
            
            {/* Abas */}
            <div style={{ display: 'flex', borderBottom: '2px solid #ddd', marginBottom: '1.5rem' }}>
              <button
                type="button"
                onClick={() => setConstrutorModalTab('construtor')}
                style={{
                  padding: '0.75rem 1.5rem',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  borderBottom: construtorModalTab === 'construtor' ? '2px solid #1b3540' : 'none',
                  color: construtorModalTab === 'construtor' ? '#1b3540' : '#666',
                  fontWeight: construtorModalTab === 'construtor' ? 'bold' : 'normal'
                }}
              >
                Construtor
              </button>
              <button
                type="button"
                onClick={() => {
                  setConstrutorModalTab('imoveis');
                  loadImoveisList();
                }}
                style={{
                  padding: '0.75rem 1.5rem',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  borderBottom: construtorModalTab === 'imoveis' ? '2px solid #1b3540' : 'none',
                  color: construtorModalTab === 'imoveis' ? '#1b3540' : '#666',
                  fontWeight: construtorModalTab === 'imoveis' ? 'bold' : 'normal'
                }}
              >
                Imóveis
              </button>
            </div>
            
            {construtorModalTab === 'construtor' ? (
            <form onSubmit={handleSubmitConstrutor} className="imovel-form">
              {/* Dados Pessoais */}
              <h3>Dados Pessoais</h3>
              <hr />
              <div className="form-row">
                <div className="form-group">
                  <label>Nome *</label>
                  <input
                    type="text"
                    value={construtorFormData.nome}
                    onChange={(e) => setConstrutorFormData({ ...construtorFormData, nome: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Tipo de Documento</label>
                  <select
                    value={construtorFormData.tipoDocumento}
                    onChange={(e) => {
                      setConstrutorFormData({ ...construtorFormData, tipoDocumento: e.target.value, cpf_cnpj: '' });
                    }}
                  >
                    <option value="CPF">CPF</option>
                    <option value="CNPJ">CNPJ</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>{construtorFormData.tipoDocumento === 'CPF' ? 'CPF' : 'CNPJ'}</label>
                  <input
                    type="text"
                    value={construtorFormData.cpf_cnpj}
                    onChange={(e) => setConstrutorFormData({ 
                      ...construtorFormData, 
                      cpf_cnpj: construtorFormData.tipoDocumento === 'CPF' ? maskCPF(e.target.value) : maskCNPJ(e.target.value)
                    })}
                    maxLength={construtorFormData.tipoDocumento === 'CPF' ? 14 : 18}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Celular Principal</label>
                  <input
                    type="text"
                    value={construtorFormData.tel_celular_principal}
                    onChange={(e) => setConstrutorFormData({ ...construtorFormData, tel_celular_principal: maskPhone(e.target.value) })}
                    placeholder="(XX) XXXXX-XXXX"
                  />
                </div>
                <div className="form-group">
                  <label>Celular Comercial</label>
                  <input
                    type="text"
                    value={construtorFormData.tel_celular_comercial}
                    onChange={(e) => setConstrutorFormData({ ...construtorFormData, tel_celular_comercial: maskPhone(e.target.value) })}
                    placeholder="(XX) XXXXX-XXXX"
                  />
                </div>
                <div className="form-group">
                  <label>Telefone Comercial</label>
                  <input
                    type="text"
                    value={construtorFormData.tel_comercial}
                    onChange={(e) => setConstrutorFormData({ ...construtorFormData, tel_comercial: maskPhone(e.target.value) })}
                    placeholder="(XX) XXXX-XXXX"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>E-mail Corporativo</label>
                  <input
                    type="email"
                    value={construtorFormData.email_corporativo}
                    onChange={(e) => setConstrutorFormData({ ...construtorFormData, email_corporativo: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>E-mail Secundário</label>
                  <input
                    type="email"
                    value={construtorFormData.email_secundario}
                    onChange={(e) => setConstrutorFormData({ ...construtorFormData, email_secundario: e.target.value })}
                  />
                </div>
              </div>

              {/* Obras */}
              <h3>Obras</h3>
              <hr />
              <div style={{ borderBottom: '1px solid #ddd', marginBottom: '1rem' }}>
                <button
                  type="button"
                  onClick={() => setActiveObraTab('empreiteiro')}
                  style={{
                    padding: '0.5rem 1rem',
                    border: 'none',
                    background: activeObraTab === 'empreiteiro' ? '#667eea' : 'transparent',
                    color: activeObraTab === 'empreiteiro' ? 'white' : '#333',
                    cursor: 'pointer',
                    marginRight: '0.5rem'
                  }}
                >
                  Empreiteiro
                </button>
                <button
                  type="button"
                  onClick={() => setActiveObraTab('mestreObra')}
                  style={{
                    padding: '0.5rem 1rem',
                    border: 'none',
                    background: activeObraTab === 'mestreObra' ? '#667eea' : 'transparent',
                    color: activeObraTab === 'mestreObra' ? 'white' : '#333',
                    cursor: 'pointer',
                    marginRight: '0.5rem'
                  }}
                >
                  Mestre de Obra
                </button>
                <button
                  type="button"
                  onClick={() => setActiveObraTab('pedreiro')}
                  style={{
                    padding: '0.5rem 1rem',
                    border: 'none',
                    background: activeObraTab === 'pedreiro' ? '#667eea' : 'transparent',
                    color: activeObraTab === 'pedreiro' ? 'white' : '#333',
                    cursor: 'pointer',
                    marginRight: '0.5rem'
                  }}
                >
                  Pedreiro
                </button>
                <button
                  type="button"
                  onClick={() => setActiveObraTab('vigia')}
                  style={{
                    padding: '0.5rem 1rem',
                    border: 'none',
                    background: activeObraTab === 'vigia' ? '#667eea' : 'transparent',
                    color: activeObraTab === 'vigia' ? 'white' : '#333',
                    cursor: 'pointer'
                  }}
                >
                  Vigia
                </button>
              </div>
              <div style={{ minHeight: '200px' }}>
                {activeObraTab === 'empreiteiro' && (
                  <div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Nome</label>
                        <input
                          type="text"
                          id="obra-empreiteiro-nome"
                          placeholder="Nome completo"
                        />
                      </div>
                      <div className="form-group">
                        <label>Telefone</label>
                        <input
                          type="text"
                          id="obra-empreiteiro-telefone"
                          placeholder="(XX) XXXXX-XXXX"
                          onChange={(e) => {
                            e.target.value = maskPhone(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button
                          type="button"
                          onClick={() => adicionarObra('empreiteiro')}
                          className="btn-save"
                          style={{ width: '100%' }}
                        >
                          Adicionar
                        </button>
                      </div>
                    </div>
                    {construtorFormData.obras?.empreiteiro?.length > 0 && (
                      <div style={{ marginTop: '1rem' }}>
                        <h4>Lista de Empreiteiros</h4>
                        <table style={{ width: '100%', marginTop: '0.5rem' }}>
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>Telefone</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {construtorFormData.obras.empreiteiro.map((obra, index) => (
                              <tr key={index}>
                                <td>{obra.nome}</td>
                                <td>{obra.telefone}</td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => removerObra('empreiteiro', index)}
                                    className="btn-action btn-delete"
                                  >
                                    <FaTrash />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
                {activeObraTab === 'mestreObra' && (
                  <div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Nome</label>
                        <input
                          type="text"
                          id="obra-mestreObra-nome"
                          placeholder="Nome completo"
                        />
                      </div>
                      <div className="form-group">
                        <label>Telefone</label>
                        <input
                          type="text"
                          id="obra-mestreObra-telefone"
                          placeholder="(XX) XXXXX-XXXX"
                          onChange={(e) => {
                            e.target.value = maskPhone(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button
                          type="button"
                          onClick={() => adicionarObra('mestreObra')}
                          className="btn-save"
                          style={{ width: '100%' }}
                        >
                          Adicionar
                        </button>
                      </div>
                    </div>
                    {construtorFormData.obras?.mestreObra?.length > 0 && (
                      <div style={{ marginTop: '1rem' }}>
                        <h4>Lista de Mestres de Obra</h4>
                        <table style={{ width: '100%', marginTop: '0.5rem' }}>
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>Telefone</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {construtorFormData.obras.mestreObra.map((obra, index) => (
                              <tr key={index}>
                                <td>{obra.nome}</td>
                                <td>{obra.telefone}</td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => removerObra('mestreObra', index)}
                                    className="btn-action btn-delete"
                                  >
                                    <FaTrash />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
                {activeObraTab === 'pedreiro' && (
                  <div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Nome</label>
                        <input
                          type="text"
                          id="obra-pedreiro-nome"
                          placeholder="Nome completo"
                        />
                      </div>
                      <div className="form-group">
                        <label>Telefone</label>
                        <input
                          type="text"
                          id="obra-pedreiro-telefone"
                          placeholder="(XX) XXXXX-XXXX"
                          onChange={(e) => {
                            e.target.value = maskPhone(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button
                          type="button"
                          onClick={() => adicionarObra('pedreiro')}
                          className="btn-save"
                          style={{ width: '100%' }}
                        >
                          Adicionar
                        </button>
                      </div>
                    </div>
                    {construtorFormData.obras?.pedreiro?.length > 0 && (
                      <div style={{ marginTop: '1rem' }}>
                        <h4>Lista de Pedreiros</h4>
                        <table style={{ width: '100%', marginTop: '0.5rem' }}>
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>Telefone</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {construtorFormData.obras.pedreiro.map((obra, index) => (
                              <tr key={index}>
                                <td>{obra.nome}</td>
                                <td>{obra.telefone}</td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => removerObra('pedreiro', index)}
                                    className="btn-action btn-delete"
                                  >
                                    <FaTrash />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
                {activeObraTab === 'vigia' && (
                  <div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Nome</label>
                        <input
                          type="text"
                          id="obra-vigia-nome"
                          placeholder="Nome completo"
                        />
                      </div>
                      <div className="form-group">
                        <label>Telefone</label>
                        <input
                          type="text"
                          id="obra-vigia-telefone"
                          placeholder="(XX) XXXXX-XXXX"
                          onChange={(e) => {
                            e.target.value = maskPhone(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button
                          type="button"
                          onClick={() => adicionarObra('vigia')}
                          className="btn-save"
                          style={{ width: '100%' }}
                        >
                          Adicionar
                        </button>
                      </div>
                    </div>
                    {construtorFormData.obras?.vigia?.length > 0 && (
                      <div style={{ marginTop: '1rem' }}>
                        <h4>Lista de Vigias</h4>
                        <table style={{ width: '100%', marginTop: '0.5rem' }}>
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>Telefone</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {construtorFormData.obras.vigia.map((obra, index) => (
                              <tr key={index}>
                                <td>{obra.nome}</td>
                                <td>{obra.telefone}</td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => removerObra('vigia', index)}
                                    className="btn-action btn-delete"
                                  >
                                    <FaTrash />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={() => { setShowConstrutorModal(false); resetConstrutorForm(); }} disabled={savingConstrutor}>
                  Cancelar
                </button>
                <button type="submit" className="btn-save" disabled={savingConstrutor}>
                  {savingConstrutor ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </form>
            ) : (
              <div className="imovel-form">
                <h3>Imóveis Relacionados</h3>
                <hr />
                
                <div className="form-group">
                  <label>Pesquisar Imóvel</label>
                  <input
                    type="text"
                    value={pesquisaImovelConstrutor}
                    onChange={(e) => setPesquisaImovelConstrutor(e.target.value)}
                    placeholder="Digite código, tipo, bairro, cidade, estado ou endereço..."
                    style={{ width: '100%', padding: '0.75rem', border: '1px solid #ddd', borderRadius: '4px' }}
                  />
                  
                  {loadingImoveisConstrutor && (
                    <div style={{ marginTop: '0.5rem', color: '#666' }}>Carregando...</div>
                  )}
                  
                  {!loadingImoveisConstrutor && pesquisaImovelConstrutor && imoveisDisponiveisConstrutor.length > 0 && (
                    <div style={{
                      marginTop: '0.5rem',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      maxHeight: '300px',
                      overflowY: 'auto',
                      backgroundColor: 'white'
                    }}>
                      {imoveisDisponiveisConstrutor.map(imovel => {
                        const jaRelacionado = construtorFormData.imoveis.some(i => i.id === imovel.id);
                        return (
                          <div
                            key={imovel.id}
                            onClick={() => !jaRelacionado && handleAdicionarImovelConstrutor(imovel.id)}
                            style={{
                              padding: '0.75rem',
                              cursor: jaRelacionado ? 'not-allowed' : 'pointer',
                              borderBottom: '1px solid #eee',
                              backgroundColor: jaRelacionado ? '#f5f5f5' : 'white',
                              opacity: jaRelacionado ? 0.6 : 1
                            }}
                            onMouseEnter={(e) => !jaRelacionado && (e.target.style.backgroundColor = '#f0f0f0')}
                            onMouseLeave={(e) => !jaRelacionado && (e.target.style.backgroundColor = 'white')}
                          >
                            <div style={{ fontWeight: 'bold', color: '#1b3540' }}>
                              {imovel.codigo} - {imovel.tipo}
                            </div>
                            <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '0.25rem' }}>
                              {imovel.bairro}, {imovel.cidade} - {imovel.estado}
                            </div>
                            {jaRelacionado && (
                              <div style={{ fontSize: '0.85rem', color: '#bf9538', marginTop: '0.25rem' }}>
                                Já relacionado
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  
                  {!loadingImoveisConstrutor && pesquisaImovelConstrutor && imoveisDisponiveisConstrutor.length === 0 && (
                    <div style={{ marginTop: '0.5rem', color: '#666' }}>
                      Nenhum imóvel encontrado
                    </div>
                  )}
                </div>
                
                {construtorFormData.imoveis.length > 0 && (
                  <div style={{ marginTop: '2rem' }}>
                    <h4 style={{ marginBottom: '1rem', color: '#1b3540' }}>Imóveis Relacionados ({construtorFormData.imoveis.length})</h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                      {construtorFormData.imoveis.map(imovel => (
                        <div
                          key={imovel.id}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '1rem',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            backgroundColor: '#f9f9f9'
                          }}
                        >
                          <div>
                            <div style={{ fontWeight: 'bold', color: '#1b3540' }}>
                              {imovel.codigo} - {imovel.tipo}
                            </div>
                            <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '0.25rem' }}>
                              {imovel.bairro}, {imovel.cidade} - {imovel.estado}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => handleRemoverImovelConstrutor(imovel.id)}
                            className="btn-action btn-delete"
                            title="Remover"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                <div className="form-actions" style={{ marginTop: '2rem' }}>
                  <button type="button" className="btn-cancel" onClick={() => { setShowConstrutorModal(false); resetConstrutorForm(); }}>
                    Fechar
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {activeTab === 'imoveis' && (
        <ImoveisTab
          imoveis={imoveis}
          pesquisaImoveis={pesquisaImoveis}
          setPesquisaImoveis={setPesquisaImoveis}
          loadingTable={loadingTable}
          filtrarImoveis={filtrarImoveis}
          agruparImoveisPorCodigo={agruparImoveisPorCodigo}
          handleEditImovel={handleEditImovel}
          handleDeleteImovel={handleDeleteImovel}
          handleDeleteTodasUnidades={handleDeleteTodasUnidades}
          setShowImovelModal={setShowImovelModal}
          loadTags={loadTags}
          pageImoveis={pageImoveis}
          setPageImoveis={setPageImoveis}
          itemsPerPageImoveis={itemsPerPageImoveis}
          setItemsPerPageImoveis={setItemsPerPageImoveis}
        />
      )}

      {activeTab === 'clientes' && (
        <ClientesTab
          clientes={clientes}
          pesquisaClientes={pesquisaClientes}
          setPesquisaClientes={setPesquisaClientes}
          loadingTable={loadingTable}
          filtrarClientes={filtrarClientes}
          getTelefoneCliente={getTelefoneCliente}
          formatCPFCNPJCliente={formatCPFCNPJCliente}
          handleEditCliente={handleEditCliente}
          handleDeleteCliente={handleDeleteCliente}
          setShowClienteModal={setShowClienteModal}
          getClientesPaginados={getClientesPaginados}
          pageClientes={pageClientes}
          setPageClientes={setPageClientes}
          itemsPerPageClientes={itemsPerPageClientes}
          setItemsPerPageClientes={setItemsPerPageClientes}
        />
      )}

      {activeTab === 'construtores' && (
        <ConstrutoresTab
          construtores={construtores}
          pesquisaConstrutores={pesquisaConstrutores}
          setPesquisaConstrutores={setPesquisaConstrutores}
          loadingTable={loadingTable}
          filtrarConstrutores={filtrarConstrutores}
          getTelefoneConstrutor={getTelefoneConstrutor}
          formatCPFCNPJConstrutor={formatCPFCNPJConstrutor}
          handleEditConstrutor={handleEditConstrutor}
          handleDeleteConstrutor={handleDeleteConstrutor}
          setShowConstrutorModal={setShowConstrutorModal}
          getConstrutoresPaginados={getConstrutoresPaginados}
          pageConstrutores={pageConstrutores}
          setPageConstrutores={setPageConstrutores}
          itemsPerPageConstrutores={itemsPerPageConstrutores}
          setItemsPerPageConstrutores={setItemsPerPageConstrutores}
        />
      )}

      {activeTab === 'agendamentos' && (
        <AgendamentosTab
          agendamentos={agendamentos}
          loadingTable={loadingTable}
          clientes={clientes}
          imoveis={imoveis}
          loadAgendamentos={loadAgendamentos}
          handleSaveAgendamento={handleSaveAgendamento}
          handleDeleteAgendamento={handleDeleteAgendamento}
        />
      )}
      </div>
    </>
  );
};

export default Dashboard;

